<template>
  <CookieBannerPc />
  <div class="mian">
    <!-- 顶部搜索栏 -->
    <div class="footer_search_mask" v-if="maskblen" @click="opendel"></div>
    <div class="right_list" :class="Collapseblen ? 'Collapse' : ''">
      <div class="right_list_top" @click="righCollapse">
        <img src="../../../assets/Homeimg/zuoliebiao1.webp" alt="" v-if="Collapseblen" />
        <img src="../../../assets/Homeimg/lujinbeifen@2x.png" alt="" v-else />
      </div>
      <div class="right_list_cnent">
        <div class="right_list_one">
          <template v-for="(item, index) in Sidebararr" :key="item">
            <div class="right_list_item" :class="selectedindex == Sidebararr[index].title
              ? 'selected'
              : 'list_item'
              ">
              <div class="icon_img">
                <first_icon :icon_name="selectedindex == Sidebararr[index].title
                  ? item.selected_icon
                  : item.unchecked_icon
                  " />
              </div>
              <div class="text" :class="selectedindex == Sidebararr[index].title
                ? 'selectedtext'
                : 'textun'
                ">
                {{ item.name }}
              </div>
              <div class="right_list_one_bottom" @click="selectedclick(item.title)"></div>
            </div>
          </template>
        </div>
        <div class="right_list_two">
          <!-- 热门项目 -->
          <hr />
          <div class="right_list_two_top">
            <div class="textbox">{{ $t('navigateBar.calegories') }}</div>
          </div>

          <!-- 热门项目列表 -->
          <template v-for="(item, index) in categories_list" :key="item" v-if="categories_list.length > 0">
            <div class="right_list_item" :class="selectedindex == item.name ? 'selected' : ''"
              @click="selectedclick(item)">
              <div class="icon_img">
                <first_icon :icon_name="selectedindex == item.name ? item.ico_s : item.ico
                  " />
              </div>
              <!-- <div class="suspended">
                {{ item.name }}
              </div> -->
              <div class="text" :class="selectedindex == item.name ? 'selectedtext' : 'textun'">
                {{ item.name }}
              </div>
            </div>
          </template>
          <!-- 加载中loding -->
          <template v-else>
            <LodingCom />
          </template>

          <hr />
        </div>
        <div class="i18nchange">
          <el-select popper-class="mySelectStyle" v-model="i18nvalue" placeholder="English" @change="changeLang"
            size="large" teleported="false">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </div>
        <div class="right_list_about">
          <div class="right_list_about_top">{{ $t('navigateBar.about') }}</div>
          <div class="right_list_about_list">
            <template v-for="(item, index) in aboutlistarr" :key="item">
              <div @click="aboutlist_item_click(index)" class="about_list_item">

                <a href="/privacy_policy.html" target='_blank' v-if="index == '3'">
                  {{ item }}
                </a>
                <a href="https://about.iglees.com" target='_blank' v-else-if="index == '0'">
                  {{ item }}
                </a>
                <a href="/terms_of_service.html" target='_blank' v-else-if="index == '4'">{{ item }}
                </a>

                <text v-else>{{ item }} </text>
              </div>
            </template>
          </div>
        </div>
        <div class="right_list_thirdparty">
          <div class="icon_box">
            <template v-for="(item, index) in thirdpartyarr" :key="item">
              <div class="icon_img" @click="thirdparty_click(index)">
                <first_icon :icon_name="item.url" />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="left_displayed">
      <header class="left_header">
        <img src="@/assets/logo3备份@2x.png" class="header_logo" @click="selectedclick('Home')" />

        <div class="header_search">
          <input type="text" :placeholder="t('Searchgame')" @input="getSeachWord_de($event)"
            @keydown.enter="search_input()" v-model="textSeach" @focus="getSeachWord_de($event)" />
          <div class="header_search_box">
            <img class="header_search_icon" src="../../../assets/Homeimg/Icon Search@2x.webp" alt=""
              @click="search_input()" />
          </div>
          <div class="header_search_list" v-if="maskblen">
            <!--搜索内容列表 -->
            <template v-if="keywordarr.length > 0" v-for="(item, index) in keywordarr" :key="item">
              <div class="search_list_item" @click="go_details(item)">
                <div class="rightimg">
                  <img :src="item.image" />
                </div>
                {{ item.name }}
              </div>
            </template>
            <!-- loading状态 -->
            <div class="spinner" v-if="sreactblen">
              <template v-for="(item, index) in 5">
                <div class="centeritem"></div>
              </template>
            </div>
            <!--无搜索内容 -->
            <div class="Nothingbox" v-if="sreacloading && keywordarr.length <= 0 && textSeach !== ''">
              <!-- -Nothing- -->
              <template v-for="(item, index) in [
                'N',
                'o',
                't',
                'h',
                'i',
                'n',
                'g',
                '.',
                '.',
                '.',
              ]">
                <span class="spanitem">{{ item }}</span>
              </template>
            </div>
            <!--搜索历史列表 -->
            <div class="Browsing_history" v-if="local_searcharr.length > 0">
              <div class="title">Last histroty search records</div>
              <!--本地历史记录 -->
              <div class="history_list">
                <template v-for="(item, index) in local_searcharr" :key="item">
                  <div class="history_item" @click="history_fill(item)">

                    <span> {{ item }}</span>

                  </div>
                </template>
              </div>
            </div>
          </div>
        </div>
        <div class="header_user">
          <template v-for="(item, index) in usericonarr" :key="item">
            <div class="header_user_img" @click="open(index)">
              <div class="icon_img">
                <first_icon :icon_name="onmouse == index ? item.slurl : item.unurl" />
              </div>
              <!-- <img :src="getImageUrl(onmouse == index ? item.slurl : item.unurl)" alt="" />   @mouseover="mouseOver(index)"  @mouseleave="mouseLeave(index)" -->
            </div>
          </template>
        </div>
      </header>
      <div class="left_displayed_content" v-loading="pageLoading" ref="outerDom">
        <!-- <div class="left_displayed_formwork" ref="sectionRef"> -->
        <router-view @feedback="Feedbackon" @gdlogin="Gdloginon" :useloginblen="useloginblen"
          @loading-start="setPageLoading(true)" @loading-end="setPageLoading(false)" />
        <!-- </div> -->
      </div>
    </div>
    <div class="backtop" @click="backTop" v-show="btnblock">
      <div class="icon_box">
        <img src="../../../assets/Homeimg/jiantou@2x.png" alt="" />
      </div>
    </div>
    <el-drawer v-model="drawer2" direction="rtl" @close="closedarw(1)">
      <div class="drawer_conent" v-if="drawer2">
        <div class="Friends_conent" v-if="openindex == '0'">
          <first_header title="Friends" @getValue="getValue">
            <template #title>
              <span>{{ $t('navigateBar.friends') }}</span>
            </template>
          </first_header>
          <div class="friends_box" v-if="useloginblen">
            <div class="friends_list" v-if="Optionsindex == '0'">
              <div class="top">
                <div class="friends_search">
                  <input type="text" :placeholder="t('FindFrieds')" @input="inputclick($event, friend_search)"
                    @keydown.enter="friend_search()" />
                  <div class="sreach_icon">
                    <img src="../../../assets/Homeimg/Icon Search@2x.webp" alt="" @click="friend_search()" />
                  </div>
                </div>
              </div>
              <div class="friends_list_item" v-if="friendsarr?.length > 0">
                <template v-for="(item, index) in friendsarr" :key="item">
                  <friends_card :friendvalue="item" @handleAdd="handleAdd" :index="Optionsindex" @dechouti="dechouti" />
                </template>
              </div>
              <div class="friends_not" v-if="friendsarr?.length == 0">
                <div class="kongbai">
                  <img src="@/assets/Homeimg/ziyuan1@3x.png" alt="" />
                </div>
                <div class="kongbai_text">
                  {{ $t('navigateBar.Invitte_your_friends') }}
                </div>
                <div class="bottomtext_text">
                  <p>
                    {{
                      $t('navigateBar.FindFriendsbySearchiingForTheirUsemames')
                    }}
                  </p>
                  <p @click="Options_click(3)">
                    <!-- {{ $t("navigateBar.or") }} -->
                    <text style="color: #00ffe0">{{ $t('navigateBar.ShareyourQrcodeinviteLink') }}
                    </text>
                  </p>
                </div>
              </div>
            </div>
            <div class="Friend_requests" v-if="Optionsindex == '1'">
              <div class="Friend_requests_title">
                {{ t('ReceivedRequest') }}
              </div>
              <div class="friends_list_item" v-if="friendgetarr?.length <= 0">
                <img src="@/assets/Homeimg/431c2c3ec41462ce63ec12f44167342.png" />
                <div class="bottomtext_text">
                  {{ t('Notyet') }}
                </div>
              </div>
              <div class="friends_list_item" v-if="friendgetarr?.length > 0">
                <template v-for="(item, index) in friendgetarr" :key="item">
                  <friends_card :friendvalue="item" @handleAdd="handleAdd" :index="Optionsindex" @dechouti="dechouti" />
                </template>
              </div>
            </div>
            <div class="Friend_application" v-if="Optionsindex == '2'">
              <div class="Friend_application_title">{{ t('SentRequest') }}</div>
              <div class="friends_list_item" v-if="friendsetarr?.length <= 0">
                <img src="@/assets/Homeimg/431c2c3ec41462ce63ec12f44167342.png" />
                <div class="bottomtext_text">
                  {{ t('Notyet') }}
                </div>
              </div>

              <div class="friends_list_item" v-if="friendsetarr?.length > 0">
                <template v-for="(item, index) in friendsetarr" :key="item">
                  <friends_card :friendvalue="item" @handleAdd="handleAdd" :index="Optionsindex" @dechouti="dechouti" />
                </template>
              </div>
            </div>
            <div class="Friend_Mine" v-if="Optionsindex == '3'">
              <div class="Friend_Mine_title">
                <p>
                  {{ $t('showqr') }}
                </p>
                {{ $t('sendyoufdre') }}
              </div>
              <div class="Friend_qr">
                <!-- <img src="../../../assets/Homeimg/二维码.webp" alt="" /> -->
                <vue-qr :text="1111" :size="280" :callback="getImgInfo"></vue-qr>
              </div>
              <div class="Friend_Share" @click="Friend_Share">
                <div class="Share_icon">
                  <img src="../../../assets/Homeimg/fenxiang1.webp" alt="" />
                </div>
                {{ $t('Shareyourprofile') }}
              </div>
              <div class="Friend_Copy" @click="Friend_Copy">
                <div class="Share_icon">
                  <img src="../../../assets/Homeimg/lujing@2x.png" alt="" />
                </div>
                {{ $t('CopyInviteLink') }}
              </div>
            </div>
          </div>
          <div class="friends_box" v-if="!useloginblen">
            <div class="loginnull">
              <img class="imgon" src="@/assets/Homeimg/ziyuan1@3x.png" alt="" />
              <div class="kongbai_text">
                {{ $t('navigateBar.Bring_your_friends') }}
              </div>
              <div class="bottomtext_text">
                <p>{{ $t('navigateBar.Create_a_CrazyGames') }}</p>
                <p>
                  <text style="color: #00ffe0">
                    {{ $t('navigateBar.start_inviting_your_friends') }}
                  </text>
                </p>
              </div>

              <div class="gologinbtn" @click="gotologin()">
                {{ $t('navigateBar.Login') }} / {{ $t('navigateBar.Register') }}
              </div>
            </div>
          </div>
          <div class="friends_list_Options" v-if="useloginblen">
            <template v-for="(item, index) in oparr" :key="item">
              <div class="Options_tab" :class="Optionsindex == index ? 'selected_tab' : ''"
                @click="Options_click(index)">
                {{ item }}
              </div>
            </template>
          </div>
        </div>
        <div class="Favorites_conent" v-if="openindex == '1'">
          <!-- 收藏游戏列表 -->
          <first_header title="Favorites" @getValue="getValue">
            <!-- favorites -->
            <template #title>
              <span>{{ $t('navigateBar.favorites') }}</span>
            </template>
          </first_header>
          <!-- <div v-if="useloginblen"> -->
          <div class="Favorites_top">
            <div class="Favorites_search">
              <input type="text" :placeholder="t('Searchbygame')" @input="inputclick($event, collect_de)"
                @keydown.enter="collect_de()" />
              <div class="sreach_icon">
                <img src="../../../assets/Homeimg/Icon Search@2x.webp" alt="" @click="collect_de()" />
              </div>
            </div>
            <!-- 时间范围筛选 -->
            <div class="timeselect">
              <el-config-provider :locale="ellocale">
                <el-date-picker v-model="timefb" popper-class="date-style" type="daterange" range-separator="|"
                  :start-placeholder="timefbtext.start" :end-placeholder="timefbtext.end" @change="collect_de"
                  format="YYYY-MM-DD" value-format="YYYY-MM-DD" />

                <!-- <el-date-picker v-model="value1" type="daterange" range-separator="To" start-placeholder="Start date"
                  end-placeholder="End date" :size="size" /> -->
              </el-config-provider>
            </div>
            <div class="Favorites_right">
              <!-- <img class="Favorites_img" src="../../../assets/Homeimg/删除2x.webp" alt="" tranbtnone /> -->
              <div class="Favorites_Delete Favorites_btn" :class="showtap ? 'tranbtnone' : ''"
                @click="delFavorite_de()">
                {{ $t('Delete') }}
              </div>
              <div class="Favorites_Manage Favorites_btn" :class="showtap ? 'tranbtn' : ''" @click="start_manage()">
                {{ showtap ? $t('navigateBar.Cancel') : $t('Manage') }}
              </div>
            </div>
          </div>

          <div class="Favorites_box">
            <div class="friends_list_item" v-if="Favoritesarr?.length <= 0">
              <img src="@/assets/Homeimg/431c2c3ec41462ce63ec12f44167342.png" />
              <div class="bottomtext_text">
                {{ t('Notyet') }}
              </div>
            </div>
            <div v-for="(val, key) in Favoritesarr" :key="key" v-else>
              <div class="Favorites_list_item">
                <div class="Favorites_list_title">{{ key }}</div>
                <div class="Favorites_cardconent">
                  <template v-for="(item1, index1) in Favoritesarr[key]" :key="item1">
                    <div class="Favorites_card">
                      <Favoritescard :videourl="item1?.video" :imgurl="item1?.image_o" :gamename="item1?.name"
                        :id="item1.id" :icon="item1.ico" :showtap="showtap" @selecttap="selecttap"
                        :checkedblen="checkedblen" />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="User_Center" v-if="openindex == '3'" v-loading="useloading">
          <div class="user_one" v-if="user_state == '1'">
            <first_header title="User Center" @getValue="getValue">
              <template #title>
                <span>{{ $t('navigateBar.user_center') }}</span>
              </template>
            </first_header>
            <div class="User_title">
              <div class="User_title_left">
                <div class="User_icon">
                  <img :src="usedata.avatar ? usedata.avatar : usefromdata.avatar" alt=""
                    v-if="!useChage && usefromdata.avatar" />
                  <img src="@/assets/Homeimg/deuserimg.jpg" alt="" v-if="!useChage && !usefromdata.avatar" />
                  <!-- ../../../assets/Homeimg/deuserimg.jpg -->
                  <label for="peas112">
                    <div class="icon" v-if="useChage">
                      <img v-if="usedata.avatar" :src="usedata.avatar" alt="" />

                      <img v-else src="@/assets/Homeimg/deuserimg.jpg" alt="" />
                      <div class="iconmask">
                        <img src="@/assets/Homeimg/xiugaixinxi@2x.webp" />
                      </div>
                    </div>
                  </label>
                  <input type="file" id="peas112" style="display: none" @change="uploudmian" data-type="shareimg" />
                </div>
                <div class="User_right">
                  <div class="User_name">
                    <div class="Chagebox" v-if="useChage">
                      <input v-model="usedata.nickname" ref="inputRef" :placeholder="usefromdata.nickname" />
                      <div class="usecompletebox" @click="handleCommand('1')">
                        {{ t('usecomplete') }}
                      </div>
                    </div>
                    <div v-if="!useChage" class="Chageboxone">
                      {{ usefromdata.nickname }}
                    </div>
                    <img class="User_name_img" src="@/assets/Homeimg/xiugaixinxi@2x.webp" @click="handleCommand('2')"
                      v-if="!useChage" />
                  </div>
                  <div class="User_eamil">{{ usefromdata.email }}</div>
                </div>
              </div>
              <div class="User_title_right" @click="gotowallet()">
                {{ $t(`navigateBar.My_wallet`) }}
              </div>
            </div>
            <div class="User_Information">
              <template v-for="(item, key, i) in usefromdata.info" :key="item">
                <div class="User_Information_item">
                  <div class="text_one">{{ item }}</div>
                  <div class="text_two">{{ $t(`navigateBar.${key}`) }}</div>
                  <!-- <div class="text_two">{{ key }}</div> -->
                </div>
              </template>
            </div>
            <div class="User_outing_history">
              <div class="User_outing_card">
                <div class="User_outing_card_title">
                  <div class="title_left">
                    {{ $t(`navigateBar.Recently_Played`) }}
                  </div>
                  <div class="title_right"></div>
                </div>

                <div class="User_outing_list_not" v-if="usefromdata.RecentlyPlayedList.length <= 0">
                  <img src="@/assets/Homeimg/431c2c3ec41462ce63ec12f44167342.png" />
                  <div class="bottomtext">
                    {{ t('Notyet') }}
                  </div>
                </div>
                <div class="User_outing_list" v-else>
                  <template v-for="item in usefromdata.RecentlyPlayedList" :key="item">
                    <div class="User_outing_list_item">
                      <useCard :listitem="item" />
                    </div>
                  </template>
                </div>
              </div>
              <div class="User_outing_card">
                <div class="User_outing_card_title">
                  <div class="title_left">
                    {{ $t(`navigateBar.Favorites`) }}
                  </div>
                  <div class="title_right"></div>
                </div>

                <div class="User_outing_list_not" v-if="usefromdata.FavoritesList.length <= 0">
                  <img src="@/assets/Homeimg/431c2c3ec41462ce63ec12f44167342.png" />

                  <div class="bottomtext">
                    {{ t('Notyet') }}
                  </div>
                </div>
                <div class="User_outing_list" v-else>
                  <template v-for="item in usefromdata.FavoritesList" :key="item">
                    <div class="User_outing_list_item">
                      <useCard :listitem="item" />
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <div class="User_bottom_btn">
              <div class="login_out btn" @click="uselogout_de()">
                {{ $t(`navigateBar.LogOut`) }}
              </div>
              <div class="dle_btn btn" @click="zhuxiao()">
                {{ $t(`navigateBar.Del_Accout`) }}
              </div>
            </div>
          </div>
          <div class="user_login" v-if="user_state == '2'">
            <first_header title="Login" @getValue="getValue">
              <template #title>
                <span>{{ $t('navigateBar.Login') }}</span>
              </template>
            </first_header>
            <div class="user_login_title">{{ $t(`navigateBar.tpal`) }}</div>
            <!-- 谷歌登录 -->
            <div class="user_login_googlebtn">
              <!-- <div class='googlebtn'>
                <img class="googlebtn_icon" src="../../../assets/Homeimg/639846264527386643@2x.webp" alt="" />
                Continue With Google
              </div> -->
              <component :is="'script'" src="https://accounts.google.com/gsi/client" ansyc />

              <!-- <div id="g_id_onload"
                data-client_id="865824439772-iqm8o5bnrstsceidhph861i65vpg5he5.apps.googleusercontent.com"
                data-context="signin" data-ux_mode="popup" data-callback="googleSignCallBack" data-auto_prompt="false">
              </div> -->

              <!-- <div class="g_id_signin" data-type="standard" data-shape="pill" data-theme="outline" data-text="signin_with"
                data-size="large" data-logo_alignment="center" data-width="400"></div> -->

              <div id="g_id_onload"
                data-client_id="410536744944-8nbkanu6smkkjn7cjcb2u9usl2kad2hc.apps.googleusercontent.com"
                data-context="signin" data-ux_mode="popup" data-callback="googleSignCallBack" data-auto_select="true"
                data-close_on_tap_outside="false" data-itp_support="true"></div>

              <div class="g_id_signin" data-type="standard" data-shape="pill" data-theme="outline"
                data-text="signin_with" data-size="large" data-logo_alignment="center" data-width="400"></div>
            </div>

            <div class="user_login_googlebtn">
              <!-- <div id="appleid-signin" data-color="black" data-border="true" data-type="sign in"></div> -->
            </div>
            <div class="Accout_login_title">
              <div class="leftone"></div>
              or
              <div class="rightone"></div>
            </div>
            <el-form class="Accout_login_Form" :model="ruleForm" ref="ruleFormRef" :rules="loginRules"
              validate-on-rule-change>
              <!-- ///////////////// -->
              <div class="Accout_login_item1">
                <el-form-item prop="email">
                  <el-input input-style="inpuone" type="text" :placeholder="t('pladdemail')" autocomplete="off"
                    class="Accout_login_input" v-model="ruleForm.email">
                    <template #prefix>
                      <img class="Accout_login_icon" src="../../../assets/Homeimg/lujing@2x (2).webp" alt="" />
                    </template>
                  </el-input>
                </el-form-item>
                <!-- <div class="validatetext">122</div> v-model="ruleForm.email" -->
              </div>
              <!-- //////////////////////// -->
              <div class="Accout_login_item2">
                <el-form-item prop="password">
                  <el-input type="password" :placeholder="t('plpassword')" autocomplete="off" class="Accout_login_input"
                    v-model="ruleForm.password" show-password>
                    <template #prefix>
                      <img class="Accout_login_icon" src="../../../assets/Homeimg/lujing@2x (1).webp" alt="" />
                    </template>
                  </el-input>
                </el-form-item>
              </div>
              <!-- ////////////////////////////////////////-->
              <div class="Accout_operation">
                <div class="left_box" @click="user_handoff('3')">
                  {{ $t(`navigateBar.newuser`)
                  }}<text> {{ $t(`navigateBar.Register`) }}</text>
                </div>
                <div class="rigt_box" @click="user_handoff('4')">
                  {{ $t(`navigateBar.Forget_Password`) }}
                </div>
              </div>
              <!-- 登录按钮 -->
              <div class="Accout_loginbtn" @click="uselogin(ruleFormRef)">
                {{ $t(`navigateBar.Login`) }}
              </div>
            </el-form>
          </div>
          <div class="user_register" v-if="user_state == '3'">
            <first_headerback title="Register" @getValue="getValue" @user_handoff="user_handoff">
              <template #title>
                <span>{{ $t('navigateBar.Register') }}</span>
              </template>
            </first_headerback>
            <el-form class="user_register_Form" :model="ruleForm" ref="ruleFormR_re" :rules="loginRules"
              validate-on-rule-change>
              <div class="user_register_item1">
                <el-form-item prop="email">
                  <el-input type="text" :placeholder="t('pladdemail')" autocomplete="off" class="Accout_login_input"
                    v-model="ruleForm.email">
                    <template #prefix>
                      <img class="user_register_icon" src="../../../assets/Homeimg/lujing@2x (2).webp" alt="" />
                    </template>
                    <template #suffix>
                      <div class="user_register_send" @click="
                        remainingTime > 0 ? '' : get_email_code('register')
                        ">

                        <div v-if="remainingTime == 0">{{ btntext }}</div>
                        <div v-if="remainingTime > 0">{{ timetext }}</div>
                      </div>
                    </template>
                  </el-input>
                </el-form-item>
              </div>
              <div class="user_register_item2">
                <el-form-item prop="captcha">
                  <el-input type="text" :placeholder="t('plemailcode')" autocomplete="off" class="Accout_login_input"
                    v-model="ruleForm.captcha">
                    <template #prefix>
                      <img class="user_register_icon user_register_icon_one"
                        src="../../../assets/Homeimg/lujing@2x.webp" alt="" />
                    </template>
                  </el-input>
                </el-form-item>
              </div>
              <div class="user_register_item2">
                <el-form-item prop="password">
                  <el-input type="password" :placeholder="t('plpassword')" autocomplete="off" class="Accout_login_input"
                    v-model="ruleForm.password" show-password>
                    <template #prefix>
                      <img class="user_register_icon" src="../../../assets/Homeimg/lujing@2x (1).webp" alt="" />
                    </template>
                  </el-input>
                </el-form-item>
              </div>
              <div class="user_register_operation">
                <div class="left_box" @click="user_handoff('2')">
                  {{ $t('navigateBar.Hasaccount')
                  }}<text> {{ $t('navigateBar.Login') }} </text>
                </div>
              </div>
              <el-form-item prop="setype">
                <div class="user_register_check">
                  <el-checkbox-group v-model="ruleForm.setype">
                    <el-checkbox value="1" name="setype"> </el-checkbox>
                  </el-checkbox-group>
                  <div class="textbox" v-html="$t('navigateBar.iam13')"></div>
                </div>
              </el-form-item>
              <!-- 注册按钮 -->
              <div class="user_register_loginbtn" @click="retap(ruleFormR_re)">
                {{ $t('navigateBar.Register') }}
              </div>
            </el-form>
          </div>
          <div class="user_register" v-if="user_state == '4'">
            <first_headerback title="Forget Password" @getValue="getValue" @user_handoff="user_handoff">
              <template #title>
                <span>{{ $t('navigateBar.Forget_Password') }}</span>
              </template>
            </first_headerback>
            <el-form class="user_register_Form" :model="ruleForm" ref="ruleFormR_pwd" :rules="loginRules"
              validate-on-rule-change>
              <div class="user_register_item1">
                <el-form-item prop="email">
                  <el-input type="text" :placeholder="t('pladdemail')" autocomplete="off" class="Accout_login_input"
                    v-model="ruleForm.email">
                    <template #prefix>
                      <img class="user_register_icon" src="../../../assets/Homeimg/lujing@2x (2).webp" alt="" />
                    </template>
                    <template #suffix>
                      <div class="user_register_send" @click="
                        remainingTime > 0 ? '' : get_email_code('resetpwd')
                        ">

                        <div v-if="remainingTime == 0">{{ btntext }}</div>
                        <div v-if="remainingTime > 0">{{ timetext }}</div>
                      </div>
                    </template>
                  </el-input>
                </el-form-item>
              </div>
              <div class="user_register_item2">
                <el-form-item prop="captcha">
                  <el-input type="text" :placeholder="t('plemailcode')" autocomplete="off" class="Accout_login_input"
                    v-model="ruleForm.captcha">
                    <template #prefix>
                      <img class="user_register_icon user_register_icon_one"
                        src="../../../assets/Homeimg/lujing@2x.webp" alt="" />
                    </template>
                  </el-input>
                </el-form-item>
              </div>
              <div class="user_register_item2">
                <el-form-item prop="password">
                  <el-input type="password" :placeholder="t('plpassword')" autocomplete="off" class="Accout_login_input"
                    v-model="ruleForm.password" show-password>
                    <template #prefix>
                      <img class="user_register_icon" src="../../../assets/Homeimg/lujing@2x (1).webp" alt="" />
                    </template>
                  </el-input>
                </el-form-item>
              </div>
              <div class="user_register_operation">
                <div class="left_box" @click="user_handoff('2')">
                  {{ $t('navigateBar.Hasaccount')
                  }}<text> {{ $t('navigateBar.Login') }} </text>
                </div>
              </div>
              <!-- 重置密码 -->
              <div class="user_register_loginbtn" @click="forget_password_de(ruleFormR_pwd)">
                {{ $t('navigateBar.Reset_Password') }}
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-drawer v-model="drawer1" destroy-on-close="true" @close="closedarw(2)">
      <div class="drawer_conent" direction="rtl" v-if="drawer1">
        <div class="Records_conent">
          <first_header title="Records" @getValue="getValue">
            <template #title>
              <span>{{ $t('navigateBar.records') }}</span>
            </template>
          </first_header>
          <div class="Records_top">
            <!-- 最近游玩记录 -->
            <div class="Records_search">
              <input type="text" :placeholder="t('Searchbygame')" @input="inputclick($event, use_recode_de)"
                @keydown.enter="use_recode_de()" />
              <div class="sreach_icon">
                <img src="../../../assets/Homeimg/Icon Search@2x.webp" alt="" />
              </div>
            </div>
            <!-- 时间范围筛选 -->
            <div class="timeselect">
              <el-config-provider :locale="ellocale">
                <el-date-picker v-model="timerc" popper-class="date-style" type="daterange" range-separator="|"
                  :start-placeholder="timefbtext.start" :end-placeholder="timefbtext.end" @change="use_recode_de"
                  format="YYYY-MM-DD" value-format="YYYY-MM-DD" />
              </el-config-provider>
            </div>
          </div>

          <div class="Records_box">
            <div class="friends_list_item" v-if="recodearr?.length <= 0">
              <img src="@/assets/Homeimg/431c2c3ec41462ce63ec12f44167342.png" />
              <div class="bottomtext_text">
                {{ t('Notyet') }}
              </div>
            </div>

            <div v-for="(val, key) in recodearr" :key="key" v-else>
              <div class="Favorites_list_item">
                <div class="Favorites_list_title">{{ key }}</div>
                <div class="Favorites_cardconent">
                  <template v-for="(item1, index1) in recodearr[key]" :key="item1">
                    <div class="Favorites_card">
                      <Favoritescard :videourl="item1?.video" :imgurl="item1?.image_o" :gamename="item1?.name"
                        :id="item1.id" :icon="item1.ico" />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-drawer v-model="drawer3" destroy-on-close="true" @close="closedarw(3)">
      <!-- 网站反馈 -->
      <div class="drawer_conent" direction="rtl" v-if="drawer3">
        <div class="Feedback_conent">
          <first_header title="Feedback" @getValue="getValue">
            <template #title>
              <span>{{ $t('navigateBar.feedback') }}</span>
            </template>
          </first_header>
          <el-form class="Feedback_box" :model="ruleForm_fb" ref="ruleFormR_Fb" :rules="rules" validate-on-rule-change>
            <div class="Feedback_item">
              <div class="Feedback_title">{{ $t('FeebackType') }}</div>
              <div class="Feedback_input">
                <el-form-item prop="type">
                  <el-select v-model="ruleForm_fb.type" :placeholder="t('plSelectfd')" popper-class="mySelectStyle">
                    <template v-for="(item, index) in feedbackarr[fbgameblen ? 1 : 0]" :key="item">
                      <el-option :label="item.value" :value="item.key" />
                    </template>
                  </el-select>
                </el-form-item>
              </div>
            </div>
            <div class="Feedback_item" v-if="fbgameblen">
              <div class="Feedback_title">{{ $t('feebackgame') }}</div>
              <div class="Feedback_input">
                <el-form-item>
                  <el-input type="text" :value="gamename" :placeholder="t('plgnsg')" readonly />
                </el-form-item>
              </div>
            </div>
            <div class="Feedback_item">
              <div class="Feedback_title">{{ $t('Your_emall') }}</div>
              <div class="Feedback_input">
                <el-form-item prop="email">
                  <el-input type="text" v-model="ruleForm_fb.email" :placeholder="t('plemail')" />
                </el-form-item>
              </div>
            </div>
            <div class="Feedback_item">
              <div class="Feedback_title">{{ $t('Screenshotproblem') }}</div>
              <div class="FeedbackScreenshot">
                <div class="updatebox">
                  <template v-for="(item, index) in issueimgarr" :key="item + index">
                    <div class="imgbox">
                      <div class="delete" @click="dle_issueimg(index)">+</div>
                      <img :src="item" alt="" />
                    </div>
                  </template>
                  <div class="uploadbox" v-if="issueimgarr.length != 3">
                    <label for="peas1123">
                      <div class="imgbox">+</div>
                    </label>
                    <input type="file" id="peas1123" style="display: none" @change="issueimg_uploud"
                      data-type="shareimg" />
                    <div class="jietu" @click="jietu">
                      {{ $t('Quickmaps') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="Feedback_item">
              <div class="Feedback_title">{{ $t('Massage') }}</div>
              <div class="Feedback_textarea">
                <el-form-item prop="message">
                  <el-input type="textarea" v-model="ruleForm_fb.message" textareaStyle="texts" />
                </el-form-item>
              </div>
            </div>
            <div class="Feedback_btn" @click="Feedbackon_de(ruleFormR_Fb)">
              {{ $t('navigateBar.feedback') }}
            </div>
          </el-form>
        </div>
      </div>
    </el-drawer>
    <el-drawer v-model="drawer4" @close="closedarw(4)">
      <!-- 合作意向 -->
      <div class="drawer_conent" direction="rtl" v-if="drawer4">
        <div class="Feedback_conent">
          <first_header title="Business Cooperation" @getValue="getValue">
            <template #title>
              <span>{{ $t('navigateBar.business_cooperation') }}</span>
            </template>
          </first_header>
          <div class="Feedback_box">
            <el-form class="Feedback_box" :model="ruleForm_bn" ref="ruleFormR_bn" :rules="rules"
              validate-on-rule-change>
              <div class="Feedback_item">
                <div class="Feedback_title">{{ $t('FeebackType') }}</div>
                <div class="Feedback_input">
                  <el-form-item prop="type">
                    <el-select v-model="ruleForm_bn.type" :placeholder="t('plSelectfd')" popper-class="mySelectStyle">
                      <template v-for="(item, index) in perationTypearr" :key="item">
                        <el-option :label="item.value" :value="item.key" />
                      </template>
                      <!-- feedbackarr -->
                    </el-select>
                  </el-form-item>
                </div>
              </div>
              <div class="Feedback_item">
                <div class="Feedback_title">{{ $t('Phoneoptional') }}</div>
                <div class="Feedback_input">
                  <el-form-item prop="phone">
                    <el-input type="text" v-model="ruleForm_bn.phone" :placeholder="t('PlIyophone')" />
                  </el-form-item>
                </div>
              </div>
              <div class="Feedback_item">
                <div class="Feedback_title">{{ $t('Your_emall') }}</div>
                <div class="Feedback_input">
                  <el-form-item prop="email">
                    <el-input type="text" v-model="ruleForm_bn.email" :placeholder="t('plemail')" />
                  </el-form-item>
                </div>
              </div>
              <div class="Feedback_item">
                <div class="Feedback_title">{{ $t('Massage') }}</div>
                <div class="Feedback_textarea">
                  <el-form-item prop="message">
                    <el-input type="textarea" v-model="ruleForm_bn.message" textareaStyle="texts" />
                  </el-form-item>
                </div>
              </div>
              <div class="Feedback_btn" @click="businesstap_de(ruleFormR_bn)">
                {{ $t('Submit') }}
              </div>
            </el-form>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-dialog v-model="dialogblen" :show-close="false" class="fsdialog" center>
      <div class="conetbox">
        <img src="../../../assets/Homeimg/erroricon.webp" alt="" />
        <p>{{ $t('navigateBar.twdya') }}</p>
        <div class="btnbox">
          <div class="left_btn btn" @click="del_account_de()">
            {{ $t('navigateBar.Confirm') }}
          </div>
          <div class="right_btn btn" @click="dialogblencancel()">
            {{ $t('navigateBar.Cancel') }}
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
  <screen-short v-if="screenshotStatus" @destroy-component="destroyComponent" @get-image-data="completeCallback"
    @webrtc-error="webrtcerror">
  </screen-short>
</template>
<script setup lang="ts">

import {
  ref,
  onMounted,
  onBeforeUnmount,
  watch,
  computed,
  reactive,
  nextTick,
  onActivated,
  provide
} from 'vue';
import { useRouter, useRoute, onBeforeRouteLeave } from 'vue-router';
import { ElConfigProvider } from 'element-plus';
import zhCn from 'element-plus/es/locale/lang/zh-cn';

// import fonts from '@/styl111.css'
//el国际化
const ellocale = ref<any>();
import { Plus } from '@element-plus/icons-vue';
import type {
  DrawerProps,
  FormInstance,
  FormRules,
  ArrowDown,
  UploadProps,
} from 'element-plus';
const direction = ref<DrawerProps['direction']>('rtl');
import first_header from '../../../components/first_comlist/first_header.vue';
import first_icon from '../../../components/first_comlist/first_icon.vue';
import first_headerback from '../../../components/first_comlist/first_headerback.vue';
import friends_card from '@/components/first_comlist/fitst_friends_card.vue';
import useCard from '@/components/first_comlist/use_cardlist/use_card/swipercard.vue';
import Favoritescard from '@/components/first_comlist/use_cardlist/Favorites_card/card_meta.vue';
import LodingCom from '@/components/lodingcom/lodingcom.vue'
import CookieBannerPc from '@/components/cookie-banner/cookie-banner-pc.vue';
import { debounce } from '../../../utils/utils';

// //导入i8n
import { useI18n } from 'vue-i18n';
// // 实例化i8n
const { t, locale } = useI18n();
import {
  getcategories_list,
  get_ems,
  useRegister,
  use_logoin,
  use_authorize,
  use_logout,
  use_resetpwd,
  use_profile,
  use_attachment,
  use_friend,
  use_received,
  use_sent,
  use_favorite,
  use_addFavorite,
  use_delFavorite,
  use_recode,
  get_getSeachWord,
  get_feedbackType,
  get_cooperationType,
  get_feedback,
  get_business,
  use_deAccount,
  use_autologin,
} from '@/request/request.ts';
import { ElMessage } from 'element-plus';
/**
 * 导入自定义消息组件 
 */

import encrypt from '@/utils/crypto-util.ts';
import vueQr from 'vue-qr/src/packages/vue-qr.vue';

/**
 * 导入firebase 监听函数
 */
import { logEventAnalytics } from '@/Firebase/firebase';
/**
 * 场景判断值 
 */
const sceneType: any = ref('1')
provide('sceneType', sceneType);


// Cookie consent is now handled by CookieBannerPc component

// 是否展示 截图容器
const screenshotStatus = ref<boolean>(false);
// 报错图片数组
const issueimgarr = ref<any>([]);
const destroyComponent = (status: boolean) => {
  screenshotStatus.value = status;
  drawer3.value = true; //显示弹框
};

//截图完成的回调
const completeCallback = async (base64data: any) => {
  console.log(base64data, '截图完成');
  let bytes = window.atob(base64data.split(',')[1]);
  //处理异常，将ASCII码小于0的转换为大于0,进行二进制转换
  let buffer = new ArrayBuffer(bytes.length);
  //生成一个8位数的数组
  let uint = new Uint8Array(buffer);
  //根据长度返回相对应的Unicode 编码
  for (let i = 0; i < bytes.length; i++) {
    uint[i] = bytes.charCodeAt(i);
  }
  //Blob对象，type为图片的格式
  let imageFile = new Blob([buffer], { type: 'image/jpeg' });
  console.log(imageFile, '处理后图片路径');
  // 处理完后上传图片
  issueimg_uploud(imageFile);
};
//webrtc模式下 用户拒绝授权或者浏览器不支持的回调
const webrtcerror = (e: any) => {
  console.log(e, 'webrtc模式下 用户拒绝授权或者浏览器不支持的回调');
  drawer3.value = true; //显示弹框
  screenshotStatus.value = false; //显示截图插件
  ElMessage.warning('用户未授权');
};
const jietu = () => {
  drawer3.value = false; //隐藏弹框
  screenshotStatus.value = true; //显示截图插件
};
// 问题图片上传
const issueimg_uploud = async (e: any) => {
  let file: any;
  if (e.target) {
    file = e.target.files[0];
  } else {
    file = e;
  }
  console.log(file);
  if (file.size / 1024 / 1024 > 2) {
    ElMessage.error('Avatar picture size can not exceed 2MB!');
    return false;
  } else {
    // 上传文件 创建FormData
    let formData = new FormData();
    // upFile就是后台接收的key
    formData.append('file', file);
    console.log(formData);
    try {
      let res = await use_attachment(formData);
      // console.log(res, "上传头像");
      if (res.status == 1) {
        console.log(res, '上传头像成功');
        // usedata.value.avatar = res.data;
        // issueimgarr.value
        issueimgarr.value.push(res.data);
      } else {
        ElMessage.error(res.msg);
      }
    } catch (error) {
      throw error;
    }
  }
};
//删除问题图片
const dle_issueimg = (index: any) => {
  issueimgarr.value = issueimgarr.value.filter((item1: any, index1: any) => {
    return index != index1;
  });
  console.log(issueimgarr.value, '更新后的数组');
};

const getImgInfo = (data: any) => {
  console.log(111, data);
};
import { useNewpageData } from '@/stroe/pinia.ts';
//导入pinia
const NewpageData = useNewpageData();
// 时间变量1
const timefb = ref<any>('');
//文档字体国际化
const timefbtext = computed(() => {
  return {
    start: t('statrtime'),
    end: t('endtime'),
    to: t('timetogo'),
  };
});
// 时间变量2
const timerc = ref<any>('');

const router = useRouter();
const route = useRoute();
//'首次页面加载进入渠道
if (route.query) {

  console.log('首次页面加载进入渠道——————————————————————————————————————', route.query.channel);
  logEventAnalytics("e_page_load", {
    uid: "",
    channel: route.query?.channel,
    referrer: route.query?.referrer,
    platform: "pc"
  })
}
const useloginblen = ref<any>(false);
const drawer2 = ref(false);
const drawer3 = ref(false);
const drawer1 = ref(false);
const drawer4 = ref(false);
const textall = ref('');
const maskblen = ref<any>(false);
const selectedindex = ref<any>('Home');
const Collapseblen = ref<any>(false);
const displayblock = ref<any>('block');
const outerDom = ref();
const sectionRef = ref();
const btnblock = ref(false);
const clientWidth = ref(true);
const leftwith = ref(191);
const Optionsindex = ref<any>('0');
const sreactblen = ref<any>(false);
const sreacloading = ref<any>(false);
// ///////// 导入i18n
const i18nvalue = ref<any>('');
const options = [
  {
    value: 'en',
    label: 'English',
  },
  {
    value: 'zh',
    label: '简体中文',
  },
];
// 安全获取语言设置
const getStoredLanguage = () => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      return localStorage.getItem('Pfdlanguage');
    }
  } catch (error) {
    console.warn('无法访问localStorage:', error);
  }
  return null;
};

// 安全设置语言
const setStoredLanguage = (lang: string) => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem('Pfdlanguage', lang);
    }
  } catch (error) {
    console.warn('无法设置localStorage:', error);
  }
};

// 初始化语言设置
const initLanguage = () => {
  const storedLang = getStoredLanguage();
  if (storedLang) {
    i18nvalue.value = storedLang;
    locale.value = storedLang;
    if (storedLang === 'zh') {
      ellocale.value = zhCn;
    } else {
      ellocale.value = '';
    }
  }
};

// 初始化语言
initLanguage();

// 切换语言
const changeLang = (data: any) => {
  console.log('切换语言到:', data);
  let uid: any = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')).id : ''
  logEventAnalytics("c_language", {
    uid: uid,
    language: data,
    platform: "pc"
  })
  // 更新i18n locale
  locale.value = data;
  i18nvalue.value = data;

  // 存储语言选择
  setStoredLanguage(data);

  // 更新Element Plus语言
  if (data === 'zh') {
    ellocale.value = zhCn;
  } else {
    ellocale.value = '';
  }

  console.log('语言切换完成:', data);
};
//用户好友列表 friendsarr friendgetarr friendsetarr
const friendsarr = ref<any>([]);
//用户收到好友请求列表
const friendgetarr = ref<any>([]);
//用户发送好友请求列表
const friendsetarr = ref<any>([]);
// 跳转到登录
const gotologin = () => {
  openindex.value = '3';
};
//登录loading
const useloading = ref(false);
const input = ref('');
const openindex = ref<any>('');
const useChage = ref<any>(false);
const inputRef = ref<any>('');
const usedata = ref<any>({
  nickname: '',
  avatar: '',
});
// 过滤 本地清除本地
const clearLocalStorageExcept = (keysToKeep: any) => {
  // 创建一个临时对象来存储需要保留的键值对
  const tempStorage = {};

  // 遍历 localStorage 中的所有键
  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (keysToKeep.includes(key)) {
      // 如果键在需要保留的列表中，将其存储在临时对象中
      tempStorage[key] = localStorage.getItem(key);
    }
  }
  // 清除 localStorage
  localStorage.clear();

  // 将临时对象中的键值对重新存储到 localStorage 中
  for (const key in tempStorage) {
    if (tempStorage.hasOwnProperty(key)) {
      localStorage.setItem(key, tempStorage[key]);
    }
  }
};

//顶部选中
const onmouse = ref<any>(null);
//监听是否token过期 或者用户消失
watch(NewpageData, (newState) => {
  if (newState.tokenblen) {
    console.log('用户保持登录状态');
    // 在这里可以执行其他页面的函数
  } else {
    console.log('用户登录状态过期执行清除');
    clearLocalStorageExcept(['Pfdlanguage']);
    usefromdata.value = {};
    user_handoff('2');
    useloginblen.value = false;
  }
});

/** google登录 */
//  Loginsuccessful: "登录成功",
// /Login failed
// Loginfailed: "登录失败",
const Loginfailed = computed(() => t('Loginfailed'));
const Loginsuccessful = computed(() => t('Loginsuccessful'));
const googleSignCallBack = async (googleUser: any) => {
  console.log('googleUser,返回信息', googleUser);
  useloading.value = true;
  console.log(
    {
      type: 1,
      clientId: googleUser.clientId,
      credential: googleUser.credential,
    },
    '谷歌数据'
  );

  // logEventAnalytics
  // c_login
  logEventAnalytics('c_login', {
    type: 2,
    platform: "pc"
  });
  try {
    let res = await use_autologin({
      type: 1,
      clientId: googleUser.clientId,
      credential: googleUser.credential,
    });
    if (res.status == 1) {
      console.log('登录成功', res);
      usefromdata.value = res.data;
      localStorage.setItem('usetoken', res.token);
      useloading.value = false;
      ElMessage.success({
        message: Loginsuccessful,

      });
      useloginblen.value = true;
      user_handoff('1');
    } else {
      console.log('登录失败', res);

      useloading.value = false;
      ElMessage.error({
        message: Loginfailed,

      });
    }
  } catch (error) {
    throw error;
  }
};

/**
 * 脸书 登录 Facebook 登录
 */
const fbSignInParams = ref<any>({
  scope: 'email,user_likes',
  return_scopes: true,
});
const FBlogin = () => {
  FB.login(function (response) {
    console.log(response, '脸书登录');
  });
};
const onSignInSuccess = (response: any) => {
  // https://developers.facebook.com/docs/graph-api/reference/user
  FB.api(
    '/me?fields=id,name,gender,first_name,last_name,email,birthday,hometown',
    (dude) => {
      console.log(`Good to see you, ${dude}.`);
    }
  );
  console.log(response); //返回第三方的登录信息 tolen等
};
const onSignInError = (error: any) => {
  console.log(error);
};
/**
 *  推特第三方登录
 */
import hello from 'hellojs/dist/hello.all.js';
const TWlogin = () => {
  hello('twitter').login();
  // Listen to signin requests
  hello.on('auth.login', function (r) {
    // Get Profile
    hello(r.network)
      .api('/me')
      .then(function (p) {
        window.console.log(p); //输出用户信息
      });
  });
};
const TWws = () => {
  hello.init(
    {
      twitter: 'REm8KjWsthsmKXZoVIYXNn1qqy',
    },
    {
      scope: 'email',
      redirect_uri: 'http://localhost:3002/',
    }
  );
};
onMounted(() => {
  /**推特谷歌方法调用 */
  window.googleSignCallBack = googleSignCallBack;
  /**推特方法调用 */
  TWws();
  // 路由刷新重置距离顶部高度
  router.afterEach(Scrollres);
});

const checkdata = ref<any>('');
const datada = () => {
  console.log('变化', checkdata.value);
};
//蒙层关闭
const opendel = () => {
  maskblen.value = !maskblen.value;
  textSeach.value = '';
};
//自动聚焦
const forucson = () => {
  nextTick(() => {
    inputRef.value.focus();
  });
};
//更改用户信息
const use_change = async () => {
  useloading.value = true;
  console.log(usedata.value, useloading.value, '用户信息');
  try {
    let res = await use_profile({
      ...usedata.value,
    });
    if (res.status == 1) {
      useloading.value = false;
      get_use_info();
      console.log('修改成功', res);
    } else {
      useloading.value = false;
      console.log('修改失败', res);
    }
  } catch (error) {
    throw error;
  }
};
// 用户信息更改选择
const handleCommand = (command: string | number | object) => {
  let uid = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')).id : ''
  console.log(command);
  console.log('进行修改信息');
  useChage.value = !useChage.value;
  if (command == '2') {
    logEventAnalytics("c_user_menu", {
      uid: uid,
      type: "1",
      btnid: "1",
      platform: "pc"
    })




    console.log('自动聚焦', inputRef);
    forucson();
    if (
      usedata.value.nickname !== usefromdata.value.nickname ||
      usedata.value.avatar !== usefromdata.value.avatar
    ) {
      usedata.value.nickname = usefromdata.value.nickname;
      usedata.value.avatar = usefromdata.value.avatar;
      console.log('进行赋值', usedata.value);
    }
  } else {
    if (
      usedata.value.nickname !== usefromdata.value.nickname ||
      usedata.value.avatar !== usefromdata.value.avatar
    ) {
      console.log('发送更新', usedata.value);
      use_change();
    } else {
      console.log('无更新', usedata.value);
    }
  }
};

//头像上传
const uploudmian = async (e: any) => {
  let file = e.target.files[0];
  console.log(file);
  if (file.size / 1024 / 1024 > 2) {
    ElMessage.error('Avatar picture size can not exceed 2MB!');
    return false;
  } else {
    // 上传文件 创建FormData
    let formData = new FormData();
    // upFile就是后台接收的key
    formData.append('file', file);
    console.log(formData);
    try {
      let res = await use_attachment(formData);
      console.log(res, '上传头像');
      if (res.status == 1) {
        console.log(res, '上传头像成功');
        usedata.value.avatar = res.data;
      }
    } catch (error) {
      throw error;
    }
  }
};

// 控制用户页面状态 1:用户详情 2:登录 3:注册 4:修改密码
const user_state = ref<any>('2');
//有本地token自动登录 qE@12345
const get_use_info = async () => {
  try {
    let res = await use_authorize({});
    console.log(res);
    if (res.status == 1) {
      console.log(res.data, '自动登录成功');
      usefromdata.value = res.data;
      useloginblen.value = true;
    }
  } catch (error) {
    throw error;
  }
};

console.log(localStorage.getItem('usetoken'));
if (localStorage.getItem('usetoken')) {
  console.log('用户已登录');
  user_state.value = '1';
  useloginblen.value = true;
  get_use_info();
} else {
  console.log('用户未登录');
  user_state.value = '2';
  useloginblen.value = false;
}

// //////////////////////////
const categories_list = ref<any>([]);
// 获取侧边栏 游戏分类tap
const getlist = async () => {
  try {
    let res = await getcategories_list();
    if (res.status == 1) {
      // console.log(res, '获取侧边栏数据成功');
      categories_list.value = res.data;
      console.log(categories_list.value, '获取侧边栏数据成功');
    }
  } catch (error) {
    throw error;
  }
};
getlist();
console.log(route, '路由数据');
// 关闭抽屉
const getValue = (e: any) => {
  console.log(e);
  drawer3.value = false;
  drawer2.value = false;
  drawer1.value = false;
  drawer4.value = false;
};
// 监听路由变化
watch(
  route,
  (newvalue, oldvalue) => {
    console.log(newvalue, '路由产生变化');
    //重置高度
    getValue(1);
    if (newvalue.params.name) {
      selectedindex.value = newvalue.params.name;
    } else {
      selectedindex.value =
        selectedindex.value !== newvalue.meta.title
          ? newvalue.meta.title
          : selectedindex.value;
    }
    if (newvalue.fullPath !== '/Message') {
      onmouse.value = null;
      console.log('不等于消息页面');
    } else {
      console.log('等于消息页面');
    }
    console.log(selectedindex, '选中变化');
  },
  { immediate: true }
);
// 用户页面返回
const user_back = () => {
  console.log('用户页面返回，重置倒计时');
  resetEmailCountdown();
  user_state.value = 2;
};
// 更新用户页面状态
const user_handoff = (num: any) => {
  console.log(`用户状态切换: ${user_state.value} -> ${num}`);
  // 重置邮箱验证码倒计时
  resetEmailCountdown();
  // 更新用户状态
  user_state.value = num;
  // 重置表单数据
  ruleForm.value = {
    email: '',
    password: '',
    captcha: '',
    setype: [],
  };

  console.log('用户状态切换完成，倒计时已重置');
};
onMounted(() => {
  console.log('dom挂载');
  window.addEventListener('scroll', Scrolldebounce, true);
});

// 组件卸载前清理定时器
onBeforeUnmount(() => {
  console.log('组件卸载，清理邮箱验证码倒计时');
  resetEmailCountdown();
  window.removeEventListener('scroll', Scrolldebounce, true);
});
// 监听滚动条
const handleScrollx = () => {
  // console.log('触发');
  if (sectionRef.value?.getBoundingClientRect()?.top <= -290) {
    btnblock.value = true;
  } else {
    btnblock.value = false;
  }
};
// 监听滚动条增加防抖
const Scrolldebounce = debounce(
  () => {
    handleScrollx();
  },
  500,
  false
);

//重置到顶部
const Scrollres = () => {
  outerDom.value.scrollTop = 0;
};
// 返回顶部
const backTop = () => {
  const timeTop = setInterval(() => {
    outerDom.value.scrollTop = outerDom.value.scrollTop -= 50;
    if (outerDom.value.scrollTop <= 0) {
      console.log(111);
      clearInterval(timeTop);
    }
  }, 5);
};
// 顶部搜索
const textSeach = ref<any>('');
const keywordarr = ref<any>([]);
const getSeachWord_de = debounce(
  (e: any) => {
    footerinput(e);
  },
  300,
  false
);
const footerinput = (e: any) => {
  maskblen.value = true;
  if (textSeach.value) {
    console.log('通过非空验证', textSeach.value);
    textSeach.value = e.target.value;
    getSeachWord(textSeach.value);
  } else {
    keywordarr.value = [];
  }
};
const footerinputblur = (e: any) => {
  console.log(e.target.value);
  e.target.value = '';
  maskblen.value = false;
  keywordarr.value = [];
};
//搜索请求
const getSeachWord = async (text: any) => {
  console.log('当前关键词', text);
  sreactblen.value = true;
  sreacloading.value = false;
  keywordarr.value = [];

  try {
    let res = await get_getSeachWord({ keyword: text });
    if (res.status == 1) {
      sreactblen.value = false;
      console.log(res.data, '搜索结果');
      if (res.data.length > 0) {
        keywordarr.value = res.data;
      } else {
        sreacloading.value = true;
      }
      // ElMessage.success(res.msg);
    } else {
      sreactblen.value = false;
      sreacloading.value = true;
      ElMessage.error(res.msg);
    }
  } catch (error) {
    sreactblen.value = false;
    sreacloading.value = true;
    console.log(error);
    throw error;
  }
};
// 字段搜索 页面跳转
const search_input = () => {
  let uid: any = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')).id : ''
  console.log(uid, '用户id');

  logEventAnalytics("c_search", {
    uid: uid,
    type: '1',
    keyword: textSeach.value,
    platform: "pc"
  })
  console.log(`/Search/${textSeach.value}`);
  maskblen.value = false;
  keywordarr.value = [];
  if (textSeach.value) {
    console.log('写入');
    history_chage(textSeach.value);
    router.push({ path: `/Search/${textSeach.value}` });
  }
};
// 搜索结果跳转
const go_details = (data: any) => {


  history_chage(data.name);
  maskblen.value = false;
  textSeach.value = '';
  router.push({ path: `/GameDetails/${data.id}` });
};
// 历史记录填充
const history_fill = (text: any) => {
  textSeach.value = text;
  search_input();
};
//写入 读取本地搜索历史
const local_searcharr = ref<any>([]);
// 读取
const get_history = () => {
  console.log(localStorage.getItem('historylist'), '读取历史');
  if (localStorage.getItem('historylist')) {
    local_searcharr.value = JSON.parse(localStorage.getItem('historylist'));
  }
};
get_history();
// 写入本地历史
function cut(value: any) {
  return value.slice(0, value.length - 1);
}
const history_chage = (text: any) => {
  if (local_searcharr.value.indexOf(text) == -1) {
    console.log(text, '写入历史');
    if (local_searcharr.value.length == 6) {
      local_searcharr.value = cut(local_searcharr.value);
      local_searcharr.value.unshift(text);
    } else {
      local_searcharr.value.unshift(text);
    }
    localStorage.setItem('historylist', JSON.stringify(local_searcharr.value));
  } else {
    return;
  }
};

////////////////////////////////////////
const Sidebararr = computed(() => [
  {
    selected_icon: 'apps-2-line 1@2x.webp',
    unchecked_icon: 'apps-2-line 2@2x.webp',
    name: t('navigateBar.Home'),
    title: 'Home',
    // HOME
  },
  {
    selected_icon: 'history-line@2x (1).webp',
    unchecked_icon: 'history-line@2x.webp',
    // name: "Reconds",
    name: t('navigateBar.records'),
    title: 'Reconds',
  },
  {
    selected_icon: 'map-line@2x (1).webp',
    unchecked_icon: 'map-line@2x.webp',
    // name: "New",
    name: t('navigateBar.New'),
    title: 'New',
  },
  {
    selected_icon: 'fire-line@2x (1).webp',
    unchecked_icon: 'fire-line@2x.webp',
    // name: "Hot",
    name: t('navigateBar.Hot'),
    title: 'Hot',
  },
  {
    selected_icon: 'bookmark-line@2x (1).webp',
    unchecked_icon: 'bookmark-line@2x.webp',
    // name: "Rank",
    name: t('navigateBar.Rank'),
    title: 'Rank',
  },
]);

const Calegoriesarr = ref([
  {
    selected_icon: 'skull-line@2x (1).webp',
    unchecked_icon: 'skull-line@2x.webp',
    name: 'Action',
  },
  {
    selected_icon: 'basketball-line@2x (1).webp',
    unchecked_icon: 'basketball-line@2x.webp',
    name: 'Sports',
  },
  {
    selected_icon: 'plant-line@2x (1).webp',
    unchecked_icon: 'plant-line@2x.webp',
    name: 'Puzzle',
  },
  {
    selected_icon: 'infrared-thermometer-line@2x (1).webp',
    unchecked_icon: 'infrared-thermometer-line@2x.webp',
    name: 'Shooting',
  },
  {
    selected_icon: 'flag-2-line@2x (1).webp',
    unchecked_icon: 'flag-2-line@2x.webp',
    name: 'Adventure',
  },
  {
    selected_icon: 'bank-card-line@2x (1).webp',
    unchecked_icon: 'bank-card-line@2x.webp',
    name: 'Card',
  },
  {
    selected_icon: 'file-2-line@2x (1).webp',
    unchecked_icon: 'file-2-line@2x.webp',
    name: 'Strategy',
  },
  {
    selected_icon: 'gamepad-line@2x (1).webp',
    unchecked_icon: 'gamepad-line@2x.webp',
    name: 'Leisure',
  },
  {
    selected_icon: 't-shirt-fill@2x (1).webp',
    unchecked_icon: 't-shirt-fill@2x.webp',
    name: 'Beauty',
  },
  {
    selected_icon: 'group-line@2x (1).webp',
    unchecked_icon: 'group-line@2x.webp',
    name: '2 Player',
  },
]);
// t("navigateBar.rank")
const aboutlistarr = computed(() => [
  t('navigateBar.about_us'),
  // t('navigateBar.contact_us'),
  t('navigateBar.feedback'),
  t('navigateBar.fqa'),
  t('navigateBar.user_privacy'),
  t('navigateBar.sbervice_Terms'),
  t('navigateBar.business_cooperation'),
  t('navigateBar.developers'),
]);

const aboutlist_item_click = (index: any) => {
  console.log(index + 1);
  let uid: any = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')).id : ''
  logEventAnalytics("c_about", {
    uid: uid,
    platform: "pc",
    aid: index + 1
  })

  if (index == '1') {
    drawer3.value = true;
  }
  if (index == '6') {
    // drawer4.value = true;
    console.log('1111111111_________');
    ElMessage.warning({
      message: t('Undercpst'),
      type: 'warning',
    });
  }
};
// 侧边栏点击处理
const selectedclick = (index: any) => {
  console.log(index, '');
  // localStorage.getItem('')
  let uid: any = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')).id : ''

  if (index !== null) {
    selectedindex.value = index.name ? index.name : index;
  }
  if (index == 'Reconds') {
    if (useloginblen.value) {
      console.log('________________');
      use_recode_de();
      drawer1.value = true;
    } else {
      drawer2.value = true;
      openindex.value = '3';
    }
  } else {
    console.log(selectedindex.value, '当前选中');
    if (selectedindex.value == 'Home') {
      router.push('/Home');
    } else if (
      selectedindex.value == 'New' ||
      selectedindex.value == 'Hot' ||
      selectedindex.value == 'Rank'
    ) {
      //
      logEventAnalytics("c_navigation", {
        uid: uid,
        nid: index + 1,
        platform: "pc"
      })
      router.push({ path: `/Categories/${index.name ? index.name : index}` });


    } else {
      logEventAnalytics("c_categories", {
        uid: uid,
        cid: index.id,
        platform: "pc"
      })
      router.push({
        path: `/ClassificationDetails/${index.id}/${index.name ? index.name : index
          }`,
      });
    }
  }
};
// 侧边栏第三方icon
const thirdpartyarr = ref([
  { url: 'img/titok@2x.png', name: 'titak' },
  {
    url: 'img/socials@2x.png',
    name: 'youtube',
    path: 'https://www.youtube.com/@iGlees',
  },
  // { url: 'img/socials1.webp', name: 'fceebook' },
  { url: 'img/X@2x1.webp', name: 'x', path: 'https://x.com/iGleesOfficial' },
  // { url: 'img/ins2x.png', name: 'ins' },
  // { url: 'img/socials (1)-1.webp', name: 'ins' },
]);
// 第三方平台官网跳转
const thirdparty_click = (index: any) => {
  console.log('第三方平台官网跳转');
  let uid: any = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')).id : ''
  logEventAnalytics("c_third_platform", {
    uid: uid,
    type: index + 1,
    platform: "pc"
  })
  if (thirdpartyarr.value[index]?.path) {
    const url = thirdpartyarr.value[index]?.path; // 你想打开的第三方网页 URL
    // 打开新窗口并加载网页
    window.open(url, '_blank');
  }
};
//第三方登录 icon
// const thirdparty_login = ref([
//   { url: "img/socials1.webp", name: "fceebook" },
//   { url: "img/socials@2x (1).png", name: "ins" },
//   { url: "img/组 36@2x.png", name: "ins" },
// ]);
// 顶部用户栏 icon
const usericonarr = ref([
  {
    slurl: 'user-heart-fill@2x.webp',
    unurl: 'user-heart-line@2x.webp',
    name: 'user',
  },
  {
    slurl: 'heart-fill@2x.webp',
    unurl: 'heart-3-line@2x.webp',
    name: 'user',
  },
  {
    slurl: 'notification-2-fill@2x.webp',
    unurl: 'notification-2-line@2x.webp',
    name: 'user',
  },
  {
    slurl: 'user-fill@2x.webp',
    unurl: 'user-line@2x.webp',
    name: 'user',
  },
]);
watch(
  drawer2,
  (newvalue, oldvalue) => {
    console.log(newvalue, '抽屉产生变化');
    if (newvalue) {
    } else {
      // onmouse.value = null
    }
  },
  { immediate: true }
);
const righCollapse = () => {
  console.log('被点击了');
  Collapseblen.value = !Collapseblen.value;
  displayblock.value = Collapseblen.value ? 'none' : 'block';
};
//onouchstart="gtouchstart(id)" ontouchend="gtouchend()"
const getImageUrl = (url: any) => {
  return new URL(url, import.meta.url).href;
};
const onSwiper = (swiper: any) => {
  console.log(swiper);
};
// 打开顶部抽屉
const open = async (index: any) => {
  console.log(useloginblen.value);
  if (index == '0' || index == '1' || index == '3') {
    drawer2.value = true;
    if (useloginblen.value) {
      openindex.value = index;
      console.log(openindex.value, '打开抽屉');
      try {
        switch (openindex.value) {
          case 0:
            await Get_use_FriendInfo_All();
            break;
          case 1:
            console.log('用户收藏');
            sceneType.value = '3'
            await get_use_collect();
            break;
          case 3:
            console.log('用户详情');
            sceneType.value = '2'
            await get_use_info();
            break;
          default:
            break;
        }
      } catch (error) {
        throw error;
      }
    } else {
      if (index == '0') {
        openindex.value = '0';
      } else {
        openindex.value = '3';
      }
    }
  } else if (index == '2') {
    console.log(index);
    if (useloginblen.value) {
      onmouse.value = index;
      router.push('/Message');
    } else {
      drawer2.value = true;
      openindex.value = '3';
      console.log(index, openindex.value);
    }
  }
};
// 抽屉搜索
const inputclick = (e: any, callback: any) => {
  textall.value = e.target.value;
  console.log(textall.value);
  // if (textall.value !== '') {
  callback();
  // }
};
// 好友底部选项数组
const oparr = computed(() => [t('List'), t('Received'), t('Sent'), t('Mine')]);
//用户社交信息全获取
const Get_use_FriendInfo_All = async () => {
  let newarr: any = [];
  try {
    newarr = await Promise.all([
      use_friend({}),
      use_received({}),
      use_sent({}),
    ]);
    let [data1, data2, data3] = newarr;
    console.log(data1, data2, data3, '获取成功');
    // friendsarr friendgetarr friendsetarr
    friendsarr.value = data1.data;
    friendgetarr.value = data2.data;
    friendsetarr.value = data3.data;
  } catch (error) {
    throw error;
  }
};

/**
 * 点击分享个人资料
 */
const Friend_Share = () => {
  let uid = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')).id : ''
  logEventAnalytics("c_user_menu", {
    uid: uid,
    type: "4",
    btnid: "5",
    platform: "pc"
  })

}
/**
 * 
 * Friend_Copy 复制资料
 */
const Friend_Copy = () => {
  let uid = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')).id : ''
  logEventAnalytics("c_user_menu", {
    uid: uid,
    type: "4",
    btnid: "6",
    platform: "pc"
  })
}

// 选择好友选项
const Options_click = (index: any) => {
  console.log(index);
  let uid: any = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')).id : ''
  logEventAnalytics("c_user_menu", {
    uid: uid,
    type: "4",
    btnid: index + 1,
    platform: "pc"
  })

  Optionsindex.value = index;

  // if (index == 0) {
  //   get_use_friend()
  // } else if (index == 1) {
  //   get_use_received()
  // } else if (index == 2) {
  //   get_use_sent()
  // }
};
// 监听朋友选项变化
// watch(Optionsindex, (newvalue, oldvalue) => {
//   console.log(newvalue, '好友选择产生变化');
// });
const User_Information_text_arr = ref([
  'Friends',
  'Favorites',
  'Game Played',
  'Game Liked',
]);

const mouseOver = (index: any) => {
  // console.log("移入");
  onmouse.value = index;
};
const mouseLeave = (index: any) => {
  // console.log("移出");
  onmouse.value = null;
};
// 表单

const ruleFormRef = ref<FormInstance>();
const ruleFormR_re = ref<FormInstance>();
const ruleFormR_pwd = ref<FormInstance>();
const ruleFormR_Fb = ref<FormInstance>();
const ruleFormR_bn = ref<FormInstance>();

//抽屉关闭回调 清除数据
const closedarw = (data: any) => {
  console.log(data, '关闭抽屉', ruleForm_bn.value?.email);
  sceneType.value = '1'
  // 如果关闭的是登录相关抽屉（drawer2包含登录模块），重置邮箱验证码倒计时
  if (data === 1) {
    console.log('关闭登录抽屉，重置邮箱验证码倒计时');
    resetEmailCountdown();
  }

  ruleFormRef.value?.resetFields();
  if (screenshotStatus.value) {
    ruleFormR_Fb.value?.resetFields();
  } else {
    issueimgarr.value = [];
  }

  ruleFormR_bn.value?.resetFields();
  timefb.value = '';
  // ruleForm_fb.value?.resetFields();
  Fidarr.value = [];
  fbgameblen.value = '';
  showtap.value = false;
};
// 正则表达式
const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{8,}$/;
// 密码校验
const passwordruler = (pass: any) => {
  return regex.test(pass);
};
// ^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@!%*?&])[A-Za-z\d@!%*?&]{8,}$
// 用户登录 参数
const ruleForm = ref<any>({
  email: '',
  password: '',
  captcha: '',
  setype: [],
});
//用户反馈参数
const ruleForm_fb = ref<any>({
  type: '',
  game_id: '',
  email: '',
  message: '',
  phone: '',
});
//用户合作参数
const ruleForm_bn = ref<any>({
  type: '',
  game_id: '',
  email: '',
  message: '',
  phone: '',
});

//email校验规则 (登录注册用，必填)
const validate_email = (rule: any, value: any, callback: any) => {
  if (!value) {
    console.log('请输入邮箱');
    callback(new Error(t('plemail')));
  } else if (!isValidEmail(value)) {
    console.log('邮箱格式错误');
    callback(new Error(t('emailformat')));
  } else {
    callback();
  }
};

//email校验规则 (反馈合作用，选填)
const validate_email_optional = (rule: any, value: any, callback: any) => {
  // 如果邮箱为空，直接通过验证（选填）
  if (!value) {
    callback();
    return;
  }

  // 如果有值，验证邮箱格式
  if (!isValidEmail(value)) {
    console.log('邮箱格式错误');
    callback(new Error(t('emailformat')));
    return;
  }

  callback();
};

// 邮箱格式验证函数
const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

// 电话格式验证函数
const isValidPhone = (phone: string): boolean => {
  // 支持国际电话格式：+国家码-区号-号码，或纯数字，或带括号、空格、横线的格式
  const phoneRegex = /^[\+]?[1-9][\d]{0,15}$|^[\+]?[(]?[\d\s\-\(\)]{7,20}$/;
  // 移除所有非数字字符后检查长度
  const digitsOnly = phone.replace(/\D/g, '');
  return phoneRegex.test(phone) && digitsOnly.length >= 7 && digitsOnly.length <= 15;
};
//password校验规则
const validate_password = (rule: any, value: any, callback: any) => {
  if (!value) {
    console.log('请输入密码');
    callback(new Error(t('plpassword')));
  } else {
    if (passwordruler(value)) {
      callback();
      console.log('校验正确');
    } else {
      console.log('密码格式错误');
      callback(new Error(t('passwordage')));
      //password
    }
  }
  callback();
};
// 验证码校验规则
const vidate_captcha = (rule: any, value: any, callback: any) => {
  if (!value) {
    console.log('请输入密码');
    callback(new Error(t('plemailcode')));
  } else {
    callback();
  }
  callback();
};
// 用户协议校验
const validate_type = (rule: any, value: any, callback: any) => {
  console.log(value);
  if (!value || value.length < 1) {
    ElMessage.error({
      message: t('UserAgreement'),
      type: 'error',
    });
    callback();
  } else {
    callback();
  }
  callback();
};
//反馈类型校验
const validate_fbtype = (rule: any, value: any, callback: any) => {
  console.log(value);
  if (!value) {
    console.log('选择反馈类型');
    callback(new Error(t('plSelectfd')));
  } else {
    callback();
  }
  callback();
};
// 反馈信息校验
const validate_message = (rule: any, value: any, callback: any) => {
  console.log(value);
  if (!value) {
    console.log('请输入您的反馈信息');
    callback(new Error(t('plfbmes')));
  } else {
    callback();
  }
  callback();
};
// 合作电话校验 (必填)
const validate_phone = (rule: any, value: any, callback: any) => {
  console.log(value);
  if (!value) {
    console.log('请输入您的电话号码');
    callback(new Error(t('plphone')));
  } else {
    callback();
  }
  callback();
};

// 合作电话校验 (选填)
const validate_phone_optional = (rule: any, value: any, callback: any) => {
  console.log(value);
  // 如果电话为空，直接通过验证（选填）
  if (!value) {
    callback();
    return;
  }

  // 如果有值，验证电话格式
  if (!isValidPhone(value)) {
    console.log('电话格式错误');
    callback(new Error(t('phoneformat')));
    return;
  }

  callback();
};

//input校验规则 (反馈合作用，邮箱电话选填)
const rules = reactive<FormRules<typeof ruleForm>>({
  email: [{ validator: validate_email_optional, trigger: 'blur' }],
  password: [{ validator: validate_password, trigger: 'blur' }],
  captcha: [{ validator: vidate_captcha, trigger: 'blur' }],
  setype: [{ type: 'array', validator: validate_type, trigger: 'change' }],
  type: [{ validator: validate_fbtype, trigger: 'change' }],
  message: [{ validator: validate_message, trigger: 'blur' }],
  phone: [{ validator: validate_phone_optional, trigger: 'blur' }],
});

//登录注册专用校验规则 (邮箱必填)
const loginRules = reactive<FormRules<typeof ruleForm>>({
  email: [{ validator: validate_email, trigger: 'blur' }],
  password: [{ validator: validate_password, trigger: 'blur' }],
  captcha: [{ validator: vidate_captcha, trigger: 'blur' }],
  setype: [{ type: 'array', validator: validate_type, trigger: 'change' }],
});
'adad'
// 触发登录
const uselogin = (formEl: FormInstance | undefined) => {
  console.log('点击登录')
  logEventAnalytics('c_login', {
    type: 1,
    platform: "pc"
  });

  if (!formEl) return;
  formEl.validate(async (valid) => {
    console.log(valid);
    if (valid) {
      useloading.value = true;
      console.log('成功', valid);
      try {
        let res = await use_logoin({
          username: ruleForm.value.email,
          password: ruleForm.value.password,
        });
        console.log(res);
        if (res.status == 1) {
          console.log('登录成功', res);
          usefromdata.value = res.data;
          localStorage.setItem('usetoken', res.token);
          localStorage.setItem('userdata', JSON.stringify(res.data))

          useloading.value = false;
          ElMessage.success({
            message: res.msg,
            type: 'sucess',
          });
          useloginblen.value = true;
          user_handoff('1');
        } else {
          useloading.value = false;
          ElMessage.error({
            message: res.msg,
            type: 'error',
          });
        }
      } catch (error) {
        throw error;
      }
    } else {
      useloading.value = false;
      console.log('失败', valid);
    }
  });
};
//获取邮箱验证码
const get_email_code = async (em: any) => {
  console.log('获取邮箱验证码', 'resetpwd2 register1');
  logEventAnalytics("c_email_code", {
    type: em == 'register' ? 1 : 2,
    platform: "pc"
  })

  // 1. 检查邮箱是否为空
  if (!ruleForm.value.email) {
    ElMessage.error({
      message: t('pladdemail'),
      type: 'error',
    });
    return;
  }

  // 2. 验证邮箱格式
  if (!isValidEmail(ruleForm.value.email)) {
    ElMessage.error({
      message: t('emailformat'),
      type: 'error',
    });
    return;
  }
  sendtime(60);



  console.log({ email: ruleForm.value.email, event: em });


  try {

    // 6. 发送验证码请求
    let res = await get_ems({ email: ruleForm.value.email, event: em });
    if (res.status == 1) {
      console.log(res);
      ElMessage.success({
        message: res.msg || t('emailsuccess'),
        type: 'success',
      });
      // 7. 开始倒计时

    } else {
      ElMessage.error({
        message: res.msg || t('emailfailed'),
        type: 'error',
      });
    }
  } catch (error) {
    console.error('发送验证码失败:', error);
    ElMessage.error({
      message: t('networkerror'),
      type: 'error',
    });
    throw error;
  } finally {

  }
};
// 发送文本国际化
const btntext = computed(() => t('Send'));
//倒计时
const timetext = ref<any>('');
const remainingTime = ref<any>(0);
// 邮箱验证码发送状态
const emailSending = ref<boolean>(false);
// 倒计时定时器ID
let countdownTimer: any = null;

const sendtime = (seconds: any) => {
  timetext.value = `${seconds}s`;
  remainingTime.value = seconds;

  // 清除之前的定时器
  if (countdownTimer) {
    clearInterval(countdownTimer);
  }

  countdownTimer = setInterval(() => {
    if (remainingTime.value <= 0) {
      clearInterval(countdownTimer);
      countdownTimer = null;
      console.log('倒计时结束');
    } else {
      console.log(`剩余时间： ${remainingTime.value}秒`);
      timetext.value = `${remainingTime.value}s`;
      remainingTime.value--;
    }
  }, 1000);
};

// 重置邮箱验证码倒计时
const resetEmailCountdown = () => {
  console.log('重置邮箱验证码倒计时');

  // 清除定时器
  if (countdownTimer) {
    clearInterval(countdownTimer);
    countdownTimer = null;
  }

  // 重置状态
  remainingTime.value = 0;
  timetext.value = '';
  emailSending.value = false;
};
// 点击注册// qE@12345 067281
const usefromdata = ref<any>({});
const register = async (formEl: FormInstance | undefined) => {
  // if(ruleForm.value.setype.length>0) return;
  // 注册收集
  logEventAnalytics("c_register", {
    platform: "pc"
  })
  if (!formEl) return;
  console.log(formEl);
  formEl.validate(async (valid) => {
    if (valid && ruleForm.value.setype.length > 0) {
      useloading.value = true;
      console.log('注册验证成功', valid, ruleForm.value);
      try {
        let res = await useRegister({
          username: ruleForm.value.email,
          password: ruleForm.value.password,
          captcha: ruleForm.value.captcha,
        });
        if (res.status == 1) {
          console.log('注册成功');
          console.log(res);
          usefromdata.value = res.data;
          useloading.value = false;
          useloginblen.value = true;
          localStorage.setItem('usetoken', res.token);
          ElMessage.success({
            message: res.msg,
            type: 'sucess',
          });
          user_handoff('1');
        } else {
          console.log(res);
          useloading.value = false;
          ElMessage.error({
            message: res.msg,
            type: 'error',
          });
        }
      } catch (error) {
        throw error;
      }
    } else {
      console.log('注册验证失败', valid);
    }
  });
};
const retap = debounce(
  (formEl: FormInstance | undefined) => {
    register(formEl);
  },
  500,
  false
);
// 注销账号 Del Accout use_deAccount
// 弹窗页面 控制
const dialogblen = ref<any>(false);
const dialogblencancel = () => {
  dialogblen.value = !dialogblen.value;
};
const del_account_de = debounce(
  () => {
    del_account();
  },
  400,
  false
);
const del_account = async () => {
  try {
    let res = await use_deAccount();
    if (res.status == 1) {
      console.log(res, '注销成功');
      ElMessage.success({
        message: res.msg,
        type: 'success',
      });
      localStorage.removeItem('usetoken');
      usefromdata.value = {};
      dialogblen.value = false;
      useloginblen.value = false;
      user_handoff('2');
    } else {
      ElMessage.error({
        message: res.msg,
        type: 'error',
      });
    }
  } catch (error) {
    throw error;
  }
};

//退出登录
const uselogout = async () => {
  let uid = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')).id : ''
  logEventAnalytics("c_user_menu", {
    uid: uid,
    type: "1",
    btnid: "3",
    platform: "pc"
  })


  useloading.value = true;
  try {
    let res = await use_logout({});
    if (res.status == 1) {
      console.log('退出成功');
      useloading.value = false;
      ElMessage.success({
        message: res.msg,
        type: 'sucss',
      });
      // MyMessage.success(res.msg)
    } else {
    }
  } catch (error) {
    throw error;
  }

  localStorage.clear();
  localStorage.removeItem('usetoken');
  usefromdata.value = {};
  user_handoff('2');
  useloginblen.value = false;
};
//注销账号
const zhuxiao = () => {
  let uid = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')).id : ''
  logEventAnalytics("c_user_menu", {
    uid: uid,
    type: "1",
    btnid: "4",
    platform: "pc"
  })
  dialogblen.value = true
}


const uselogout_de = debounce(
  () => {
    uselogout();
  },
  500,
  false
);
/////////////////////////////////
//忘记密码 修改密码
const forget_password = async (formEl: FormInstance | undefined) => {
  // 忘记密码
  logEventAnalytics("c_forgot_pwd", {
    platform: "pc"
  })
  if (!formEl) return;
  console.log(formEl);
  formEl.validate(async (valid) => {
    if (valid) {
      useloading.value = true;
      console.log('更改验证成功', valid);

      try {
        let res = await use_resetpwd({
          email: ruleForm.value.email,
          password: ruleForm.value.password,
          captcha: ruleForm.value.captcha,
        });
        console.log(res);
        if (res.status == 1) {
          useloading.value = false;
          console.log('更改成功');
          ElMessage.success({
            message: res.msg,
            type: 'sucess',
          });
          console.log(res);
          localStorage.removeItem('usetoken');
          usefromdata.value = {};
          user_handoff('2');
        } else {
          useloading.value = false;
          ElMessage.error({
            message: res.msg,
            type: 'error',
          });
        }
      } catch (error) {
        throw error;
      }
    } else {
      console.log('更改验证失败', valid);
    }
  });
};
const forget_password_de = debounce(
  (formEl: FormInstance | undefined) => {
    forget_password(formEl);
  },
  500,
  false
);
//////////////////////////////////////////////////////
//获取好友信息
const get_use_friend = async () => {
  try {
    let res = await use_friend({});
    console.log(res);
    if (res.status == 1) {
      console.log('获取成功好友信息成功', res);
      friendsarr.value = res.data;
    }
  } catch (error) {
    throw error;
  }
};
//获取收到信息列表
const get_use_received = async () => {
  try {
    let res = await use_received({});
    if (res.status == 1) {
      console.log('获取成功收到信息列表', res);
      friendsarr.value = res.data;
    }
  } catch (error) {
    throw error;
  }
};
// 获取请求发送列表 use_sent
const get_use_sent = async () => {
  try {
    let res = await use_sent({});
    if (res.status == 1) {
      console.log('获取成功发送信息列表', res);
      friendsarr.value = res.data;
    }
  } catch (error) {
    throw error;
  }
};
// 子传父 触发好友列表事件
const handleAdd = (item: any) => {
  console.log(item);
  // get_use_received()
};
// 子传父 关闭抽屉
const dechouti = (item: any) => {
  console.log(item);
  // getValue()
};
//模糊搜索 friend_search
const search = async (value: string) => {
  // if (textall.value !== '') {
  console.log(textall.value, '文本');
  let uid: any = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')).id : ''
  logEventAnalytics("c_search", {
    uid: uid,
    type: "2",
    keyword: textall.value,
    platform: "pc"
  })

  try {
    let res = await use_friend({ nickname: textall.value });
    if (res.status == 1) {
      console.log('获取成功', res);
      if (res.data.length > 0) {
        friendsarr.value = res.data;
      } else {
        ElMessage.warning(t('NoUsersFound'));

      }
    }
  } catch (error) {
    throw error;
  }
};
const friend_search = debounce(
  (value: string) => {
    search(value);
  },
  300,
  false
);
/**
 *   我的钱包
 */
const gotowallet = () => {

  let uid: any = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')).id : ''
  logEventAnalytics("c_user_menu", {
    uid: uid,
    type: "1",
    btnid: "2",
    platform: "pc"
  })

}


//////////////////////
// 获取用户收藏列表
// 是否展示选择
const showtap = ref<any>(false);
// 当前否选中
const checkedblen = ref<any>(false);
// 收藏列表
const Favoritesarr = ref<any>('');
const get_use_collect = async () => {
  try {
    let res = await use_favorite({});
    if (res.status == 1) {
      Favoritesarr.value = res.data;
      console.log(Favoritesarr.value, '收藏列表');
    }
  } catch (error) {
    throw error;
  }
};
// 模糊搜索收藏列表
const collect_de = debounce(
  (timesrtr) => {
    collect_search(timesrtr);
  },
  300,
  false
);
const collect_search = async (value: string) => {
  let uid: any = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')).id : ''
  logEventAnalytics("c_search", {
    uid: uid,
    type: '3',
    keyword: textall.value,
    platform: "pc"
  })

  console.log(value, '搜索时间');
  let obj: Object;
  value
    ? (obj = { keyword: textall.value, startTime: value[0], endTime: value[1] })
    : (obj = { keyword: textall.value });
  try {
    let res = await use_favorite(obj);
    if (res.status == 1) {
      Favoritesarr.value = res.data;
      console.log(Favoritesarr.value, '搜索收藏列表');
    }
  } catch (error) {
    throw error;
  }
};

// 开启收藏列表管理
const start_manage = () => {
  let uid: any = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')).id : ''
  logEventAnalytics("c_user_menu", {
    uid: uid,
    type: "3",
    btnid: "1",
    platform: "pc"
  })
  showtap.value = !showtap.value;
  if (!showtap.value) {
    console.log('取消收藏列表管理,清空');
    checkedblen.value = false;
    Fidarr.value = [];
  }
};

//收集选择游戏id
const Fidarr = ref<any>([]);
const selecttap = (item: any) => {
  console.log(item, '选择的游戏');
  if (item.sblen) {
    Fidarr.value.push(item.gid);
    console.log(Fidarr.value, '已经收集id');
  } else {
    Fidarr.value = Fidarr.value.filter((item1: any) => {
      return item1 != item.gid;
    });
    console.log(Fidarr.value, '已经取消收集id');
  }
};
const delFavorite_de = debounce(
  () => {
    Fidarr.value.length > 0 ? delFavorite() : ElMessage.error(t('plselefg'));
  },
  300,
  false
);
// 删除游戏收藏
const delFavorite = async () => {
  let uid: any = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')).id : ''
  logEventAnalytics("c_user_menu", {
    uid: uid,
    type: "3",
    btnid: "2",
    platform: "pc"
  })
  console.log('删除收藏', Fidarr.value, '');
  try {
    let res = await use_delFavorite({ gid: Fidarr.value });
    if (res.status == 1) {
      NewpageData.setgid(Fidarr.value);
      console.log(res, '删除成功');
      ElMessage.success(res.msg);
      get_use_collect();
    } else {
      ElMessage.success(res.msg);
    }
  } catch (error) {
    throw error;
  }

  Fidarr.value = [];
};
// 获取最近游玩记录
const recodearr = ref<any>([]);
const use_recode_de = debounce(
  (tiemstr) => {
    get_use_recode(tiemstr);
  },
  300,
  false
);
const get_use_recode = async (value: string) => {
  console.log(value, '游玩记录查询');
  let obj: Object;
  value
    ? (obj = { keyword: textall.value, startTime: value[0], endTime: value[1] })
    : (obj = { keyword: textall.value });

  try {
    let res = await use_recode(obj);
    if (res.status == 1) {
      console.log(res, '获取成功');
      recodearr.value = res.data;
      // ElMessage.success(res.msg)
    } else {
      ElMessage.success(res.msg);
    }
  } catch (error) {
    throw error;
  }
};
//游戏页面触发反馈
const fbgameblen = ref<any>();
const gamename = ref<any>([]);
const Feedbackon = (item: any) => {
  let { blen, name, id } = item;
  console.log(item, '游戏反馈触发');
  drawer3.value = true;
  fbgameblen.value = blen;
  ruleForm_fb.value.game_id = id;
  gamename.value = name;
};
const Gdloginon = () => {
  drawer2.value = true;
  openindex.value = '3';
};
// 触发反馈
const Feedbackon_de = debounce(
  (formEl: FormInstance | undefined) => {
    feedbacktap(formEl);
  },
  300,
  false
);
const feedbacktap = (formEl: any) => {
  console.log(ruleForm_fb.value);
  if (!formEl) return;
  console.log(formEl);
  formEl.validate(async (valid: any) => {
    if (valid) {
      let uid: any = localStorage.getItem('userdata') ? JSON.parse(localStorage.getItem('userdata')).id : ''
      logEventAnalytics("e_feedback", {
        uid: uid,
        gid: ruleForm_fb.value.game_id ? ruleForm_fb.value.game_id : '',
        type: ruleForm_fb.value.game_id ? '2' : '1',
        text: ruleForm_fb.value.message,
        platform: "pc"
      })




      console.log('反馈验证成功', valid, {
        ...ruleForm_fb.value,
        plateform: fbgameblen.value ? 1 : 2,
        images: issueimgarr.value,
      });
      try {
        let res = await get_feedback({
          ...ruleForm_fb.value,
          plateform: fbgameblen.value ? 1 : 2,
          images: issueimgarr.value,
        });
        if (res.status == 1) {
          console.log(res, '反馈成功');
          ruleFormR_Fb.value?.resetFields();
          drawer3.value = false;
          ElMessage.success({
            message: res.msg,
            type: 'sucess',
          });
        } else {
          console.log(res, '反馈失败');
          ElMessage.error({
            message: res.msg,
            type: 'error',
          });
        }
      } catch (error) {
        throw error;
      }
    } else {
      console.log('反馈验证失败', valid);
    }
  });
};
//触发合作反馈
const businesstap_de = debounce(
  (formEl: FormInstance | undefined) => {
    businesstap(formEl);
  },
  300,
  false
);
const businesstap = (formEl: any) => {
  console.log(ruleForm_bn.value);
  if (!formEl) return;
  console.log(formEl);
  formEl.validate(async (valid) => {
    if (valid) {
      console.log('反馈验证成功', valid);

      try {
        let res = await get_business({
          ...ruleForm_bn.value,
        });
        if (res.status == 1) {
          console.log(res, '反馈成功');
          ruleFormR_bn.value?.resetFields();
          drawer4.value = false;
          ElMessage.success({
            message: res.msg,
            type: 'sucess',
          });
        } else {
          console.log(res, '反馈失败');
          ElMessage.error({
            message: res.msg,
            type: 'error',
          });
        }
      } catch (error) {
        throw error;
      }
    } else {
      console.log('反馈验证失败', valid);
    }
  });
};
// 获取全部反馈列表
const feedbackarr = ref<any>([]);
const get_feedbackty = async () => {
  // let res = await get_feedbackType({plateform:2});
  let newarr: any = [];
  try {
    newarr = await Promise.all([
      get_feedbackType({ plateform: 2 }),
      get_feedbackType({ plateform: 1 }),
    ]);
    console.log(newarr, '获取全部反馈列表成功');
    newarr.forEach((item: any, index: any) => {
      if (item.status == 1) {
        feedbackarr.value.push(item.data);
      } else {
        console.log('反馈失败');
      }
    });
    console.log(feedbackarr.value);
  } catch (error) {
    console.error('报错', error);
    throw error;
  }
};
get_feedbackty();

const perationTypearr = ref<any>([]);

const get_perationType = async () => {
  try {
    let res = await get_cooperationType({});
    if (res.status == 1) {
      console.log(res, '合作获取成功');
      perationTypearr.value = res.data;
      // ElMessage.success(res.msg)
    } else {
      ElMessage.error(res.msg);
    }
  } catch (error) {
    throw error;
  }
};
get_perationType();
///////////////////////////////////////

// 页面loading状态
const pageLoading = ref(false);

// 设置页面loading状态
const setPageLoading = (status: boolean) => {
  pageLoading.value = status;
  console.log('页面loading状态:', status);
};
</script>
<style lang="less" scoped>
.inpuone {
  height: 200px;
}

::v-deep(.el-dialog) {
  width: 520px !important;
  height: 300px !important;
  background: linear-gradient(180deg,
      #1a2734 0%,
      rgba(75, 80, 230, 1) 100%) !important;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  // margin: 0;
  box-sizing: border-box;
}

.fsdialog {}

.jietubtn {
  width: 100%;
  height: 50px;
  background: wheat;
}

.conetbox {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;

  img {
    width: 88px;
    height: 80px;
    // margin-top: 50px;
  }

  p {
    color: white;
    font-size: 24px;
    font-weight: 600;
    margin-top: 20px;
  }

  .btnbox {
    width: auto;
    height: auto;
    margin-top: 30px;
    display: flex;
    justify-content: center;

    .btn {
      transition-duration: 0.2s;
    }

    .btn:hover {
      opacity: 0.7;
    }

    .btn:active {
      transform: scale(0.95);
    }

    .left_btn {
      width: 160px;
      height: 50px;
      border-radius: 10px;
      border: 1px solid #00ffe0;
      text-align: center;
      line-height: 50px;
      color: rgba(0, 255, 224, 1);
      font-size: 20px;
      margin-right: 20px;
    }

    .right_btn {
      width: 260px;
      height: 50px;
      border-radius: 10px;
      background: #00ffe0;
      text-align: center;
      line-height: 50px;
      color: rgba(50, 63, 116, 1);
      font-size: 20px;
    }
  }
}

::v-deep(.el-dialog__body) {
  width: 100% !important;
  height: 100% !important;
  // background: wheat;
}

::v-deep(.el-form-item.is-error .el-input__wrapper) {
  // box-shadow: none;
  // box-shadow: 0 0px 0px transparent !important;
}

::v-deep(.swiper-slide) {
  width: auto !important;
}

// ::v-deep(.el-input__wrapper) {
//   margin: 0 !important;
//   padding: 0 !important;
//   background: transparent;
//   height: 57px;
//   // border: 1.28px solid #00ffe0;
//   border-radius: 16px;
//   box-shadow: 0 0 0 1px #00ffe0 inset;
//   padding-left: 28px !important;
//   padding-right: 28px !important;

//   .el-input__inner {
//     color: #fff;
//   }
//   .el-form-item__error{
//     font-size:14px;
//   }

// }

::v-deep(.el-checkbox__inner:after) {
  bottom: 0;
  top: 0;
  right: 0;
  left: 0;
  margin: auto;
  width: 4px;
  height: 8px;
}

// el-select
::v-deep(.el-select) {
  height: 100% !important;
}

// .el-textarea__inner
::v-deep(.el-textarea__inner) {
  margin: 0 !important;
  padding: 0 !important;
  background: transparent;
  box-shadow: none !important;
  min-height: 163px !important;
}

::v-deep(.el-select__wrapper) {
  margin: 0 !important;
  padding: 0 !important;
  background: transparent;
  box-shadow: none !important;
  font-size: 18px !important;
  height: 100%;

  .el-select__suffix {
    width: 24px !important;
    height: 24px !important;
  }
}

::v-deep(.el-icon svg) {
  width: 100% !important;
  height: 100% !important;
}

::v-deep(.el-icon) {
  width: 24px !important;
  height: 24px !important;
}

::v-deep(.el-input__inner) {
  // cursor: default !important;
  // background: transparent !important;
  color: #cacaca !important;
}

::v-deep(.el-form-item) {
  margin: 0;
  flex: 1;
}

::v-deep(.el-drawer.rtl) {
  width: 1047px !important;
  height: 100%;
  background: linear-gradient(180deg,
      #1a2734 0%,
      rgba(75, 80, 230) 100%) !important;
}

::v-deep(.el-drawer__header) {
  display: none !important;
}

::v-deep(.el-drawer__body) {
  // display: none !important;
  margin: 0 !important;
  padding: 0 !important;
}

.cebianlan {
  width: 1000px !important;
}

.mian {
  width: 100%;
  height: 100%;
  background: url('@/assets/Homeimg/beijintu@2x (2).png') no-repeat;
  background-size: cover;
  display: flex;

  ::v-deep(.el-loading-spinner) {
    --el-color-primary: rgba(0, 255, 224, 1) !important;
  }

  ::v-deep(.el-loading-mask) {
    background-color: rgba(0, 0, 0, 0.4);
    border-radius: 10px;
  }

  .backtop {
    width: 64px;
    height: 64px;
    position: fixed;
    right: 40px;
    bottom: 50px;
    background: rgba(251, 109, 58, 0.1);
    border-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    display: flex;
    z-index: 5;
    transition-duration: 0.5s;

    .icon_box {
      width: 28px;
      height: 28px;
      // background: #FB6D3A;
      border-radius: 50%;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }

  .footer_search_mask {
    width: 100%;
    height: 100%;
    background: rgba(35, 30, 47, 0.85);
    position: absolute;
    top: 0;
    opacity: 1;
    animation-name: mask-show;
    animation-duration: 0.6s;
    z-index: 99;
  }

  @keyframes mask-show {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  .Collapse {
    width: 73px !important;
    overflow: hidden;
  }

  .right_list {
    width: 172px;
    height: 100%;
    display: flex;
    flex-direction: column;
    transition-duration: 0.1s;
    flex-shrink: 0;

    .right_list_top {
      width: 100%;
      height: 67px;
      display: flex;
      justify-content: center;
      align-items: center;

      img {
        width: 21px;
        height: 21px;
      }
    }

    .right_list_top:hover {
      opacity: 0.5;
      transition-duration: 0.2s;
    }

    .right_list_cnent {
      width: 100%;
      flex: 1;
      overflow-y: scroll;
      // padding-top: 50px;
      box-sizing: border-box;

      .i18nchange {
        width: 130px;
        height: 39px;
        // background: red;
        margin-left: 20px;
        margin-top: 30px;
        margin-bottom: 30px;
        overflow: hidden;

        box-sizing: border-box;
        border: 1px solid rgba(255, 255, 255, 0.12);
        border-radius: 6px;
        display: v-bind('displayblock');

        ::v-deep(.el-select) {
          width: 100%;
          color: white;

          .el-select__wrapper {
            width: 130px !important;
            height: 39px !important;
            padding-right: 10px !important;
            line-height: none !important;
          }
        }

        ::v-deep(.el-select__placeholder) {
          color: white !important;
          font-size: 14px !important;
          text-align: center;
          line-height: 36px;
        }

        ::v-deep(.el-icon) {
          height: 17px !important;
        }
      }

      .selectedtext {
        color: #00ffe0;
      }

      hr {
        width: 80%;
        border-width: 0;
        border-style: solid;
        border-color: rgba(255, 255, 255, 0.12);
        border-bottom-width: thin;
        margin: auto;
      }

      .right_list_one {
        width: 100%;
        height: auto;
        padding-top: 46px;
        position: relative;

        .right_list_one_bottom {
          position: absolute;
          top: 0;
          width: 100%;
          height: 100%;
          // background: rgba(0, 0, 0, 0.2);
          // pointer-events: none;
          border-radius: 15px;
        }

        .right_list_item {
          width: 100%;
          min-height: 24px;
          position: relative;
          margin-bottom: 25px;
          display: flex;
          align-items: center;
          color: white;
          border-top-left-radius: 15px;
          border-bottom-left-radius: 15px;
          font-size: 15px;
          box-sizing: border-box;

          // padding-left: 5px;
          // padding-left: 29px;
          .icon_img {
            width: 24px;
            height: 24px;
            margin-left: 24px;
            flex-shrink: 0;
          }

          .text {
            margin-left: 25px;
            transition-duration: 0.2s;
            // flex-shrink: 0;
            // background: wheat;

          }

        }

        .right_list_item:hover .textun {
          margin-left: 30px;
          opacity: 0.4;
        }

        .selected {
          // background: rgba(52, 52, 68, 0.3);
        }

        .selected::before {
          content: '';
          width: 46px;
          height: 46px;
          position: absolute;
          top: -46px;
          right: 0px;
          // background: radial-gradient(circle at left top,
          //     transparent 85%,
          //     rgba(52, 52, 68, 0.3) 85%);
        }

        .selected::after {
          content: '';
          width: 46px;
          height: 46px;
          position: absolute;
          bottom: -46px;
          right: 0px;
          // background: radial-gradient(circle at left bottom,
          //     transparent 85%,
          //     rgba(52, 52, 68, 0.3) 85%);
        }
      }

      .right_list_two {
        width: 100%;
        min-height: 206px;
        display: flex;
        flex-direction: column;

        // margin-left: 24px;
        // margin-top: 30px;
        // position: relative;
        box-sizing: border-box;
        align-content: space-between;

        hr {
          width: 80%;
          margin: auto;
          flex-shrink: 0;
          border-width: 0;
          border-style: solid;
          border-color: rgba(255, 255, 255, 0.12);
          border-bottom-width: thin;
        }

        .right_list_two_top {
          width: 100%;
          height: 20px;
          color: white;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 20px;
          margin-top: 30px;

          .textbox {
            display: v-bind('displayblock');
          }
        }

        .right_list_item {
          width: 100%;
          min-height: 24px;
          position: relative;
          margin-bottom: 25px;
          display: flex;
          align-items: center;
          color: white;
          border-top-left-radius: 15px;
          border-bottom-left-radius: 15px;
          font-size: 15px;
          box-sizing: border-box;

          // padding-left: 29px;
          .icon_img {
            width: 24px;
            height: 24px;
            margin-left: 24px;
            flex-shrink: 0;
          }

          .text {
            margin-left: 25px;

            transition-duration: 0.2s;

          }
        }

        .right_list_item:hover .textun {
          margin-left: 30px;
          opacity: 0.4;
        }

        .selected {
          // background: rgba(52, 52, 68, 0.3);
        }

        .selected::before {
          content: '';
          width: 46px;
          height: 46px;
          position: absolute;
          top: -46px;
          right: 0px;
          // background: radial-gradient(circle at left top,
          //     transparent 85%,
          //     rgba(52, 52, 68, 0.3) 85%);
        }

        .selected::after {
          content: '';
          width: 46px;
          height: 46px;
          position: absolute;
          bottom: -46px;
          right: 0px;
          // background: radial-gradient(circle at left bottom,
          //     transparent 85%,
          //     rgba(52, 52, 68, 0.3) 85%);
        }
      }

      .right_list_about {
        width: 100%;
        height: 330px;
        // margin-left: 24px;
        display: v-bind('displayblock');

        // content: 
        .right_list_about_top {
          width: 80%;
          height: 20px;
          color: white;
          display: flex;
          // align-items: center;
          font-weight: bold;
          // justify-content: center;
          font-size: 20px;
          // margin: auto;
          margin-left: 26px;
          margin-bottom: 20px;
        }

        .right_list_about_list {
          width: 80%;
          height: calc(100% - 77px);
          box-sizing: border-box;

          .about_list_item {
            width: 100%;
            min-height: 18px;
            font-size: 14px;
            color: #bababa;
            display: flex;
            padding-left: 26px;
            margin-bottom: 20px;
          }

          .about_list_item:hover {
            opacity: 0.7;
          }
        }
      }

      .right_list_thirdparty {
        width: 100%;
        height: 400px;
        display: v-bind('displayblock');
        // display: none;
        box-sizing: border-box;

        // overflow: hidden;
        // background: red;
        // justify-content: center;

        .icon_box {
          width: 100%;
          height: 100px;
          // background: wheat;
          margin-top: 40px;
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          // background: white;
          // justify-content: center !important;

          box-sizing: border-box;
          padding: 5px;
          margin-left: 10px;
          padding-left: 10px;

          .icon_img {
            width: 40px;
            height: 40px;
            overflow: hidden;
            border-radius: 5px;
            transition-duration: 0.3s;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .icon_img:hover {
            transform: scale(1.2);
          }
        }
      }
    }

    .right_list_cnent::-webkit-scrollbar {
      display: none !important;
    }
  }

  .left_displayed {
    width: 30%;
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;

    .left_header {
      width: 100%;
      height: 67px;
      border-bottom: 1px solid rgba(138, 138, 160, 0.4);
      display: flex;
      align-items: center;
      justify-content: space-between;

      .header_logo {
        width: 114px;
        height: 50px;
        font-weight: bold;
        font-size: 24px;
        color: white;
        line-height: 41px;
        margin-left: 34px;
      }

      .header_search {
        width: 493px;
        height: 40px;
        border-radius: 24px;
        opacity: 1;
        box-sizing: border-box;
        border: 1px solid #5142fc;
        display: flex;
        align-items: center;
        justify-content: space-between;
        position: relative;
        z-index: 100;
        font-size: 16px;
        padding-left: 15px;

        input {
          border: none;
          width: 392px;
          height: 40px;
          display: flex;
          align-items: center;

          background: none;
          outline: none;
          outline: 0;
          font-size: 16px;
          color: #00ffe0;
          font-weight: normal;
          /* 重置样式 */
          appearance: none;
          -webkit-appearance: none;

          /* 确保盒模型一致 */
          box-sizing: border-box;

          /* 使用更精确的居中方法 */
          display: flex;
          align-items: center;
          justify-content: center;
          /* 或使用绝对定位 */
          position: relative;

          /* 统一行高和文字对齐 */
          line-height: normal;
          /* 或使用具体像素值 */
          vertical-align: middle;

          /* 消除字体渲染差异 */
          -webkit-font-smoothing: antialiased;

          /* 处理2K屏幕 */
          transform: translateZ(0);
          /* 启用GPU加速 */

          /* 确保内边距一致 */
          padding: 0;

          /* 兼容苹果设备的字体 */
          font-family: -apple-system, BlinkMacSystemFont, sans-serif;
        }

        input::placeholder {
          color: rgba(255, 255, 255, 0.6);
          font-size: 16px;
        }

        .header_search_box {
          width: 35px;
          height: 35px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 10px;

          .header_search_icon {
            width: 20px;
            height: 20px;
          }
        }

        .header_search_box:hover {
          background: linear-gradient(180deg,
              #1a2734 0%,
              rgba(75, 80, 230, 0.3) 100%);
        }

        .header_search_list {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, 30px);
          width: 428px;
          min-height: 40px;
          // border-radius: 0px 0px 8px 8px;
          border-radius: 8px;
          opacity: 1;
          background: linear-gradient(180deg,
              #1a2734 0%,
              rgba(75, 80, 230, 0.3) 100%);
          border: 1px solid #1a2734;
          box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
          border-radius: box-sizing;
          padding: 10px 30px;
          transition-duration: 0.3s;
          overflow-y: scroll;

          .search_list_item {
            width: 100%;
            height: 50px;
            margin-bottom: 5px;
            margin-top: 5px;
            color: white;
            display: flex;
            align-items: center;
            border-radius: 10px;
            font-size: 14px;
            font-weight: 700;

            .rightimg {
              width: 80px;
              height: 50px;
              border-radius: 5px;
              overflow: hidden;
              margin-right: 20px;
              transition-duration: 0.2s;

              img {
                width: 80px;
                height: 50px;
              }
            }
          }

          .search_list_item:nth-child(1) {
            background: linear-gradient(180deg,
                #1a2734 0%,
                rgba(75, 80, 230, 0.3) 100%);
          }

          .search_list_item:hover {
            background: linear-gradient(180deg,
                #1a2734 0%,
                rgba(75, 80, 230, 0.3) 100%);
          }

          .Browsing_history {
            width: 100%;
            min-height: 60px;
            display: flex;
            flex-direction: column;
            margin-top: 20px;

            .title {
              width: 100%;
              font-size: 12px;
              height: 13px;
              color: #00ffe0;
              text-align: center;
            }

            .history_list {
              width: 100%;
              min-height: 40px;
              display: flex;
              flex-wrap: wrap;
              grid-gap: 8px;
              grid-auto-rows: 50px;
              box-sizing: border-box;
              margin-top: 20px;

              .history_item {
                min-width: 50px;
                max-width: 120px;
                /* 添加最大宽度限制 */
                height: 30px;
                transition-duration: 0.3s;
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
                box-sizing: border-box;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                padding: 5px 10px;
                color: white;
                border: 0.5px solid #4b50e6;
                border-radius: 15px;
                cursor: pointer;
              }

              /* 在.history_item内部添加一个包装元素处理文本 */
              .history_item span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                width: 100%;
                text-align: center;
                // height: 100%;
                // text-align: center;

              }

              .history_item:hover {
                opacity: 0.7;
              }

              .history_item:active {
                transform: scale(0.95);
              }
            }
          }

          .spinner {
            width: 100%;
            height: 60px;
            // background:wheat;
            display: flex;
            align-items: center;
            justify-content: center;
            color: rgba(0, 255, 224, 1);
            font-weight: bold;
            font-size: 20px;

            .centeritem {
              width: 10px;
              height: 15px;
              background: rgba(0, 255, 224, 1);
              margin: 2px;
              // border-radius: 50%;
              border-radius: 3px;
              animation: stretchdelay 1s infinite ease-in-out;
            }

            .centeritem:nth-child(1) {
              animation-delay: 0;
            }

            .centeritem:nth-child(2) {
              animation-delay: -1.1s;
            }

            .centeritem:nth-child(3) {
              animation-delay: -1.2s;
            }

            .centeritem:nth-child(4) {
              animation-delay: -1.3s;
            }

            .centeritem:nth-child(5) {
              animation-delay: -1.4s;
            }

            @keyframes stretchdelay {
              0% {
                transform: scale(1);
                opacity: 1;
              }

              20% {
                transform: scale(0.5);
                opacity: 0.5;
              }

              100% {
                transform: scale(1);
                opacity: 1;
              }
            }
          }

          .Nothingbox {
            color: rgba(0, 255, 224, 1);
            width: 100%;
            height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;

            .spanitem {
              width: auto;
              height: auto;
              // background: #3498db;
              opacity: 1;
              margin: 1px;
              font-size: 16px;
              border-radius: 100%;
              text-align: center;
              animation: anim 0.7s ease-in-out;
            }

            .spanitem:nth-child(1) {
              animation-delay: 0.5s;
            }

            .spanitem:nth-child(2) {
              animation-delay: 0.7s;
            }

            .spanitem:nth-child(3) {
              animation-delay: 0.9s;
            }

            .spanitem:nth-child(4) {
              animation-delay: 1.1s;
            }

            .spanitem:nth-child(5) {
              animation-delay: 1.3s;
            }

            .spanitem:nth-child(6) {
              animation-delay: 1.5s;
            }

            .spanitem:nth-child(7) {
              animation-delay: 1.7s;
            }

            .spanitem:nth-child(8) {
              animation-delay: 1.9s;
            }

            .spanitem:nth-child(9) {
              animation-delay: 2.1s;
            }

            .spanitem:nth-child(10) {
              animation-delay: 2.3s;
            }

            @keyframes anim {
              75% {
                opacity: 1;
                transform: translateY(-5px);
                // background: rgba(0, 255, 224, 1);
              }

              100% {
                opacity: 1;
                transform: translateY(0px);
              }
            }
          }
        }
      }

      .header_user {
        width: 268px;
        height: 100%;
        // background: red;
        display: flex;
        align-items: center;
        justify-content: center;

        .header_user_img {
          width: 24px;
          height: 24px;
          margin-right: 45px;
          display: flex;
          justify-content: center;
          align-items: center;
          transition-duration: 0.2s;

          .icon_img {
            width: 100%;
            height: 100%;
          }
        }

        .header_user_img:hover {
          opacity: 0.5;
        }
      }
    }

    .left_displayed_content {
      width: 100%;
      flex: 1;
      flex-shrink: 0;
      overflow-y: scroll;

      // .left_displayed_formwork {
      //   width: 100%;
      //   flex: 1;
      //   border-radius: 5px;
      //   margin-top: 30px;
      //   padding-top: 1px;
      //   overflow: hidden;
      // }
    }
  }

  // .el-drawer.rtl
  .drawer_conent {
    width: 100%;
    height: 100%;

    box-sizing: border-box;

    .Friends_conent {
      width: 100%;
      height: 100%;
      padding-left: 43px;
      padding-right: 43px;
      box-sizing: border-box;

      display: flex;
      flex-direction: column;

      .friends_box {
        width: 100%;
        flex: 1;
        overflow-y: scroll;
        display: flex;
        flex-direction: column;

        // background: wheat;
        .friends_list {
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          overflow: hidden;

          .top {
            width: 100%;
            height: 114px;
            display: flex;
            align-items: center;

            .friends_search {
              display: flex;
              align-items: center;
              justify-content: space-between;
              position: relative;
              width: 100%;
              height: 40px;
              border-radius: 18px;
              opacity: 1;
              box-sizing: border-box;
              border: 1px solid #5142fc;

              // margin-bottom: 74px;
              input {
                border: none;
                flex: 1;
                height: 100%;
                margin-left: 15px;
                background: none;
                outline: none;
                outline: 0;
                font-size: 14px;
                color: #00ffe0;
                font-weight: normal;
              }

              input::placeholder {
                color: white;
                font-weight: 16px;
              }

              .sreach_icon {
                margin-right: 15px;
                margin-left: 20px;
                width: auto;
                height: 100%;
                // background: wheat;
                border-radius: 50%;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                  width: 22px;
                  height: 22px;
                }
              }

              .sreach_icon:hover {
                background: linear-gradient(180deg,
                    #1a2734 0%,
                    rgba(75, 80, 230, 0.3) 100%);
              }
            }
          }

          .friends_list_item {
            width: 100%;
            flex: 1;
            overflow-y: scroll;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            img {
              height: 270px;
            }

            .bottomtext_text {
              width: 249px;
              min-height: 26px;
              margin: auto;
              text-align: center;
              margin-top: 18px;
              margin-bottom: 30px;
              font-size: 26px;
              font-weight: 600;
              color: white;
            }
          }

          .friends_not {
            width: 100%;
            height: 100%;

            .kongbai {
              width: 397px;
              height: 270px;
              opacity: 1;
              margin: auto;

              img {
                width: 397px;
                height: 270px;
              }
            }

            .kongbai_text {
              width: 249px;
              min-height: 26px;
              margin: auto;
              text-align: center;
              margin-top: 18px;
              margin-bottom: 30px;
              font-size: 26px;
              font-weight: 600;
              color: white;
            }

            .bottomtext_text {
              width: 636px;
              min-height: 26px;
              margin: auto;
              color: #ffffff;
              line-height: 30px;
              font-weight: 400;
              font-size: 20px;
              text-align: center;
            }
          }
        }

        .Friend_requests {
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          overflow: hidden;

          // background: wheat;
          .Friend_requests_title {
            width: 100%;
            height: 94px;
            font-size: 18px;
            color: rgba(3, 237, 213, 1);
            display: flex;
            align-items: center;
          }

          .friends_list_item {
            width: 100%;
            flex: 1;
            overflow-y: scroll;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            img {
              height: 270px;
            }

            .bottomtext_text {
              width: 249px;
              min-height: 26px;
              margin: auto;
              text-align: center;
              margin-top: 18px;
              margin-bottom: 30px;
              font-size: 26px;
              font-weight: 600;
              color: white;
            }
          }
        }

        .Friend_application {
          width: 100%;
          flex: 1;
          display: flex;
          flex-direction: column;
          overflow: hidden;

          .Friend_application_title {
            width: 100%;
            height: 94px;
            font-size: 18px;
            color: rgba(3, 237, 213, 1);
            display: flex;
            align-items: center;
          }

          .friends_list_item {
            width: 100%;
            flex: 1;
            overflow-y: scroll;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            img {
              height: 270px;
            }

            .bottomtext_text {
              width: 249px;
              min-height: 26px;
              margin: auto;
              text-align: center;
              margin-top: 18px;
              margin-bottom: 30px;
              font-size: 26px;
              font-weight: 600;
              color: white;
            }
          }
        }

        .Friend_Mine {
          width: 100%;
          min-height: 548px;
          // margin-top: 50px;
          display: flex;
          align-items: center;
          flex-direction: column;

          .Friend_Mine_title {
            width: 100%;
            height: 78px;
            font-size: 20px;
            color: white;
            // text-justify: distribute;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            align-content: space-around;
            margin-top: 80px;
            margin-bottom: 54px;
            text-align: center;
          }

          .Friend_qr {
            width: 242px;
            height: 242px;
            border-radius: 5px;
            overflow: hidden;
            margin-bottom: 37px;
            aspect-ratio: 1/1;

            img {
              width: 100%;
              height: 100%;
            }
          }

          // Share your profile
          .Friend_Share {
            box-sizing: border-box;
            width: 474px;
            height: 64px;
            border-radius: 10px;
            background: linear-gradient(180deg,
                #ffffff 0%,
                rgba(255, 255, 255, 0) 100%),
              #00ffe0;
            background-blend-mode: overlay, normal;
            margin-bottom: 36px;
            font-size: 18px;
            color: #323f74;

            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            transition-duration: 0.2s;

            .Share_icon {
              width: 25px;
              height: 25px;
              // margin-right: 56px;
              position: absolute;
              left: 35px;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }

          .Friend_Share:hover {
            opacity: 0.7;
          }

          .Friend_Share:active {
            transform: scale(0.95);
          }

          .Friend_Copy {
            box-sizing: border-box;
            width: 474px;
            height: 64px;
            border-radius: 10px;
            transition-duration: 0.2s;
            border: 1.28px solid #00ffe0;
            margin-bottom: 56px;
            font-size: 18px;
            color: #ffffff;

            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;

            .Share_icon {
              width: 25px;
              height: 25px;
              // margin-right: 56px;
              position: absolute;
              left: 35px;

              img {
                width: 100%;
                height: 100%;
              }
            }
          }

          .Friend_Copy:hover {
            opacity: 0.7;
          }

          .Friend_Copy:active {
            transform: scale(0.95);
          }
        }

        .loginnull {
          width: 100%;
          height: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          .imgon {
            width: 379px;
            height: 270px;
            // margin-top: 120px;
          }

          .kongbai_text {
            min-width: 249px;
            min-height: 26px;
            margin: auto;
            text-align: center;
            margin-top: 18px;
            margin-bottom: 40px;
            font-size: 26px;
            font-weight: 600;
            color: white;
          }

          .bottomtext_text {
            width: 636px;
            min-height: 26px;
            color: #ffffff;
            line-height: 30px;
            font-weight: 400;
            font-size: 20px;
            text-align: center;
          }

          .gologinbtn {
            width: 474px;
            height: 64px;
            background: #00ffe0;
            box-shadow: 0px 2px 21px 0px rgba(0, 0, 0, 0.2),
              0px 8px 10px 0px rgba(0, 0, 0, 0.12),
              0px 4px 8px 0px rgba(0, 0, 0, 0.14);
            border-radius: 10px;
            font-weight: 600;
            font-size: 20px;
            text-align: center;
            line-height: 64px;
            margin-top: 50px;
            transition-duration: 0.2s;
          }

          .gologinbtn:hover {
            opacity: 0.7;
          }

          .gologinbtn:active {
            transform: scale(0.95);
          }
        }
      }

      .friends_list_Options {
        width: 630px;
        height: 100px;
        // background: red;
        display: flex;
        align-items: center;
        justify-content: space-around;
        // margin-top: 147px;
        margin: auto;

        .Options_tab {
          min-width: 80px;
          height: 42px;
          border-radius: 8px;
          color: #ffffff;
          font-weight: bold;
          font-size: 20px;
          display: flex;
          justify-content: center;
          align-items: center;
          border: 1px solid transparent;
          transition-duration: 0.2s;
          box-sizing: border-box;
          padding: 10px;
        }

        .Options_tab:hover {
          opacity: 0.5;
        }

        .selected_tab {
          border: 1px solid #00ffe0;
          color: #00ffe0;
        }
      }
    }

    .Favorites_conent {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding-left: 43px;
      padding-right: 43px;
      display: flex;
      flex-direction: column;
      overflow-y: scroll;

      .Favorites_top {
        width: 100%;
        height: 48px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;
        align-items: center;

        .Favorites_search {
          height: 48px;
          width: 320px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          // position: relative;

          border-radius: 24px;
          opacity: 1;
          box-sizing: border-box;
          border: 1px solid #5142fc;

          // margin-bottom: 93px;
          input {
            border: none;
            width: 100%;
            height: 26px;
            margin-left: 15px;
            background: none;
            outline: none;
            outline: 0;
            font-size: 16px;
            color: #00ffe0;
            font-weight: normal;
          }

          input::placeholder {
            color: white;
            // font-weight: 400;
          }

          .sreach_icon {
            margin-right: 15px;
            width: auto;
            height: 100%;
            flex-shrink: 0;
            // background: wheat;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;

            img {
              width: 22px;
              height: 22px;
            }
          }

          .sreach_icon:hover {
            background: linear-gradient(180deg,
                #1a2734 0%,
                rgba(75, 80, 230, 0.3) 100%);
          }
        }

        .Favorites_right {
          width: 250px;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;

          .Favorites_btn {
            width: 118px;
            height: 48px;
            border-radius: 24px;
            box-sizing: border-box;
            font-size: 18px;
            font-weight: 350;
            color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            transition: all 0.3s ease;

            // padding:10px;
          }

          .Favorites_btn:hover {
            opacity: 0.8;
          }

          .Favorites_btn:active {
            transform: scale(0.9);
          }

          .Favorites_img {
            width: 22px;
            height: 22px;
            // margin-right: 25px;
          }

          .Favorites_Delete {
            border: 1px solid #ffffff;
            translate: 50% 0px;
            opacity: 0.3;
          }

          .Favorites_Manage {
            background: linear-gradient(239deg, #e250e5 9%, #4b50e6 89%);
            border: 1px solid #5142fc;
            translate: -50% 0px;
          }

          .tranbtn {
            translate: 0px 0px;
          }

          .tranbtnone {
            translate: -10px 0px;
            opacity: 1;
          }
        }
      }

      // Favorites_top
      .timeselect {
        width: 320px;
        height: 50px;

        ::v-deep(.el-date-editor.el-input__wrapper) {
          height: 46px !important;
          width: 320px !important;
          background-color: transparent !important;
          border-radius: 24px !important;
          border: 1px solid #5142fc !important;
          box-shadow: none !important;
          padding: 0 15px !important;
          box-sizing: border-box !important;
        }

        ::v-deep(.el-date-editor .el-range-input) {
          color: rgba(255, 255, 255, 0.6) !important;
          font-size: 16px !important;
          height: 100% !important;
          // display: flex !important;
          // justify-content: center !important;
          // align-items: center !important;
          line-height: 100px !important;
        }

        ::v-deep(.el-date-editor .el-range-separator) {
          color: rgba(255, 255, 255, 0.6) !important;
        }
      }

      .Favorites_box {
        width: 100%;
        flex: 1;
        overflow-y: scroll;

        .friends_list_item {
          width: 100%;
          height: 100%;
          flex: 1;
          overflow-y: scroll;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          img {
            height: 270px;
          }

          .bottomtext_text {
            width: 249px;
            min-height: 26px;
            margin: auto;
            text-align: center;
            margin-top: 18px;
            margin-bottom: 30px;
            font-size: 26px;
            font-weight: 600;
            color: white;
          }
        }

        .Favorites_list_item {
          width: 100%;
          height: 100%;

          .Favorites_list_title {
            width: 100%;
            height: 26px;
            font-size: 18px;
            color: #00ffe0;
            font-weight: bold;
          }

          .Favorites_cardconent {
            width: auto;
            min-height: 221px;
            margin: 18px auto 39px;
            display: grid;
            flex-wrap: wrap;
            grid-template-columns: repeat(4, 210px);
            grid-gap: 7px;
            justify-content: center;
            // background: white;

            .Favorites_card {
              width: 210px;
              height: 240px;
              border-radius: 5px;
              flex-shrink: 0;
              // margin-bottom: 20px;
              overflow: hidden;
            }
          }
        }
      }
    }

    .User_Center {
      width: 100%;
      height: 100%;

      ::v-deep(.el-input__wrapper) {
        margin: 0 !important;
        padding: 0 !important;
        background: transparent;
        height: 57px;
        // border: 1.28px solid #00ffe0;
        border-radius: 10px;
        box-shadow: 0 0 0 1px #00ffe0 inset;
        padding-left: 28px !important;
        padding-right: 28px !important;

        .el-input__inner {
          color: #fff;
        }

        // .el-form-item__error {
        //   font-size: 14px !important;
        //   top: 113% !important;
        // }
      }

      ::v-deep(.el-form-item__error) {
        // top: calc(100% + 20px);
        font-size: 14px;
        top: 113% !important;
      }

      .user_one {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        overflow-y: scroll;
        padding-left: 80px;
        padding-right: 80px;
        box-sizing: border-box;

        .User_title {
          width: 100%;
          height: 42px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 20px;

          .User_title_left {
            min-width: 211px;
            height: 100%;
            display: flex;
            align-items: center;

            input {
              background: transparent;
              border: none;
              box-shadow: none;
              color: white;
              font-size: 18px;
              // width:100%;
              margin: 0;
              padding: 0;
            }

            .User_icon {
              width: 63px;
              height: 63px;
              border-radius: 50%;
              background: white;
              margin-right: 16px;
              overflow: hidden;
              display: flex;
              position: relative;

              .icon {
                width: 63px;
                height: 63px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 20px;
              }

              img {
                width: 100%;
                height: 100%;
              }

              .iconmask {
                position: absolute;
                background: rgba(32, 43, 68, 0.5);
                top: 0;
                width: 63px;
                height: 63px;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                  width: 20px;
                  height: 20px;
                }

                img:hover {
                  opacity: 0.7;
                }
              }
            }

            .User_right {
              width: 300px;
              height: 63px;
              display: flex;
              flex-direction: column;
              justify-content: space-around;

              .User_name {
                width: 100%;
                font-size: 24px;
                font-weight: bold;
                color: white;
                display: flex;
                height: auto;
                align-items: center;
                height: 33px;
                visibility: visible;

                .User_name_img {
                  cursor: pointer;

                }

                .User_name_img:hover {
                  opacity: 0.7;
                }

                .Chagebox {
                  width: 100%;
                  border-radius: 20px;
                  background: #313d70;
                  height: 33px;
                  border: 1px solid #00fcdd;
                  display: flex;
                  align-items: center;
                  box-sizing: border-box;

                  input {
                    width: 100%;
                    font-size: 24px;
                    font-weight: bold;
                    box-sizing: border-box;

                    color: white;
                    flex: 1;
                    // padding: 0;
                    box-shadow: none !important;
                    outline: none;
                    padding-left: 10px;
                    padding-right: 10px;
                  }

                  input::placeholder {
                    color: white;
                  }

                  .usecompletebox {
                    min-width: 102px;
                    height: 33px;
                    border-radius: 20px;
                    opacity: 1;
                    background: #00fedf;
                    font-size: 16px;
                    text-align: center;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #323f74;
                    font-weight: bold;
                    box-sizing: border-box;
                    padding: 10px;
                  }
                }

                .Chageboxone {
                  min-width: 100px;
                  box-sizing: border-box;
                  padding-left: 10px;
                  padding-top: 1px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  flex-wrap: nowrap;
                  height: 33px;
                  border: 1px solid transparent;
                }

                img {
                  width: 20px;
                  height: 20px;
                  margin-left: 20px;
                }
              }

              .User_eamil {
                width: 100%;
                font-size: 14px;
                color: #a1a1a1;
                box-sizing: border-box;
                padding-left: 11px;
              }
            }
          }

          .User_title_right {
            width: 130px;
            height: 48px;
            border-radius: 24px;
            background: linear-gradient(239deg, #e250e5 9%, #4b50e6 89%);
            box-sizing: border-box;
            border: 1px solid #5142fc;
            color: white;
            font-size: 18px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }

          .User_title_right:hover {
            opacity: 0.7;
          }
        }

        .User_Information {
          width: 100%;
          height: 40px;
          // background: wheat;
          display: flex;
          margin-top: 35px;
          margin-bottom: 20px;
          align-items: center;
          justify-content: space-around;

          .User_Information_item {
            height: 100%;
            min-width: 80px;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            // align-content: space-around;
            // margin-right: 87px;
            align-items: center;

            .text_one {
              min-width: 21px;
              height: 17px;
              text-align: center;
              line-height: 17px;
              font-size: 20px;
              color: #ffffff;
              text-align: center;
              margin-bottom: 10px;
              font-weight: bold;
            }

            .text_two {
              min-width: 57px;
              height: 17px;
              font-size: 14px;
              color: #a1a1a1;
              text-align: center;
              font-weight: bold;
            }
          }
        }

        .User_outing_history {
          width: 100%;
          flex: 1;
          // background: wheat;
          overflow-y: scroll;

          .User_outing_card {
            width: 100%;
            min-height: 200px;
            margin-top: 30px;

            .User_outing_card_title {
              width: 100%;
              height: 17px;
              display: flex;
              justify-content: space-between;
              margin-bottom: 20px;

              .title_left {
                min-width: 212px;
                font-size: 18px;
                color: #00ffe0;
                box-sizing: border-box;
                font-weight: bold;
              }

              .title_right {
                width: 97px;
                height: 17px;
                font-size: 14px;
                color: #00ffe0;
                text-align: right;
                line-height: 17px;
              }
            }

            .User_outing_list_not {
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              img {
                height: 230px;
              }

              .bottomtext {
                margin-top: 32px;
                width: 100%;
                font-weight: 600;
                font-size: 26px;
                text-align: center;
                margin-top: 20px;
                color: white;
              }
            }

            .User_outing_list {
              width: 100%;
              min-height: 254px;
              display: grid;
              flex-wrap: wrap;
              grid-template-columns: repeat(4, 1fr);
              grid-gap: 7px;
              justify-content: space-between;

              .User_outing_list_item {
                width: 100%;
                height: 100%;
                border-radius: 5px;
                // background: wheat;
                flex-shrink: 0;
              }
            }
          }
        }

        .User_bottom_btn {
          width: 100%;
          height: 80px;
          display: flex;
          margin-top: 19px;
          margin-bottom: 8px;
          flex-direction: row-reverse;

          .dle_btn {
            border: 1px solid #ffffff;
            margin-right: 16px;
          }

          .login_out {
            background: linear-gradient(239deg, #e250e5 9%, #4b50e6 89%);
            border: 1px solid #5142fc;
          }

          .btn {
            min-width: 138px;
            height: 48px;
            border-radius: 24px;
            color: white;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 16px;
            transition-duration: 0.2s;
          }

          .btn:hover {
            opacity: 0.5;
          }

          .btn:active {
            transform: scale(0.95);
          }
        }
      }

      .user_login {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow-y: scroll;
        padding-left: 43px;
        padding-right: 43px;
        box-sizing: border-box;

        .user_login_title {
          width: 328px;
          height: 26px;
          font-size: 18px;
          color: white;
          // margin: auto;
          margin-top: 43px;
          text-align: center;
          margin-bottom: 42px;
          font-weight: bold;
        }

        .user_login_googlebtn {
          position: relative;
          min-width: 380px;
          height: 57px;
          // background: linear-gradient(180deg,
          //     #ffffff 0%,
          //     rgba(255, 255, 255, 0) 100%),
          //   #00ffe0;
          background-blend-mode: overlay, normal;
          border-radius: 10px;
          font-size: 20px;
          color: #323f74;
          box-sizing: border-box;

          display: flex;
          align-items: center;
          font-weight: 500;
          margin-bottom: 18px;

          // overflow: hidden;
          .googlebtn {
            position: absolute;
            top: 0px;
            width: 100%;
            height: 100%;
            height: 57px;
            display: flex;
            justify-content: center;
            align-items: center;

            .googlebtn_icon {
              width: 25px;
              height: 25px;
              margin-right: 34px;
            }
          }
        }

        .user_login_googlebtn:hover {
          opacity: 0.6;
        }

        .user_login_googlebtn:active {
          transform: scale(0.95);
        }

        .third_party {
          width: 232px;
          height: 32px;
          display: flex;
          justify-content: space-between;
          margin-bottom: 61px;

          .third_party_icon {
            width: 32px;
            height: 32px;
          }
        }

        .Accout_login_title {
          width: 207px;
          height: 20px;
          font-size: 18px;
          color: white;
          text-align: center;
          margin-bottom: 25px;
          font-weight: bold;
          display: flex;
          justify-content: center;
          align-items: center;

          .leftone {
            width: 50px;
            height: 1px;
            background: white;
            margin-right: 3px;
          }

          .rightone {
            width: 50px;
            height: 1px;
            background: white;
            margin-left: 3px;
          }
        }

        // .Accout_login {
        //     width: 474px;
        //     min-height: 206px;

        .Accout_login_Form {
          width: 380px;
          min-height: 206px;

          // background: wheat;

          .Accout_login_icon {
            width: 25px;
            height: 25px;
            margin-right: 17px;
          }

          .Accout_login_item1 {
            width: 100%;
            height: 57px;

            // padding-top: 16px;
            // padding-bottom: 16px;

            display: flex;
            align-items: center;
            box-sizing: border-box;
            margin-bottom: 43px;
            position: relative;

            .validatetext {
              position: absolute;
              width: 80%;
              height: 20px;
              // background: wheat;
              bottom: -20px;
              color: red;
              font-size: 14px;
              display: flex;
              align-items: center;
            }
          }

          .Accout_login_item2 {
            width: 100%;
            height: 57px;

            border-radius: 16px;

            display: flex;
            align-items: center;
            box-sizing: border-box;
            margin-bottom: 43px;
            position: relative;

            .validatetext {
              position: absolute;
              width: 80%;
              height: 20px;
              // background: wheat;
              bottom: -20px;
              color: red;
              font-size: 14px;
              display: flex;
              align-items: center;
            }
          }

          .Accout_operation {
            width: 100%;
            height: 26px;
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            color: #ffffff;
            margin-bottom: 121px;
            margin-top: 60px;

            // text-align: center;
            text {
              color: #00ffe0;
            }

            .rigt_box {
              color: #00ffe0;
              height: 26px;
              line-height: 26px;
            }

            .left_box {
              height: 26px;
              line-height: 26px;
            }
          }

          .Accout_loginbtn {
            width: 226px;
            height: 38px;
            border-radius: 18px;
            opacity: 1;
            background: linear-gradient(257deg, #e250e5 12%, #4b50e6 87%);
            box-sizing: border-box;
            border: 1px solid #5142fc;
            margin: auto;
            font-size: 18px;
            font-weight: bold;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }

      .user_register {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        overflow-y: scroll;

        box-sizing: border-box;

        .user_register_Form {
          width: 379px;
          min-height: 206px;
          // background: wheat;

          .user_register_icon {
            width: 25px;
            height: 25px;
            margin-right: 18px;
          }

          .user_register_icon_one {
            width: 23px !important;
          }

          .user_register_item1 {
            width: 100%;
            height: 60px;
            // border: 1px solid #00ffe0;
            border-radius: 16px;
            // padding-top: 20px;
            // padding-bottom: 20px;
            // padding-right: 36px;
            display: flex;
            align-items: center;
            box-sizing: border-box;
            margin-bottom: 34px;

            .user_register_send {
              width: 58px;
              height: 100%;
              font-size: 18px;
              color: #c6c6c6;
              border-left: 1px solid #00ffe0;
              display: flex;
              align-items: center;
              justify-content: flex-end;
              transition-duration: 0.2s;
            }

            .user_register_send:hover {
              opacity: 0.5;
            }

            .user_register_send:active {
              transform: scale(0.95);
            }
          }

          .user_register_item2 {
            width: 100%;
            height: 57px;

            border-radius: 16px;

            display: flex;
            align-items: center;
            box-sizing: border-box;
            margin-bottom: 34px;
          }

          .user_register_operation {
            width: 100%;
            height: 26px;
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            color: #ffffff;
            margin-bottom: 29px;

            box-sizing: border-box;
            padding-top: 20px;

            text {
              color: #00ffe0;
            }

            .rigt_box {
              color: #00ffe0;
              height: 26px;
              line-height: 26px;
            }

            .left_box {
              height: 26px;
              line-height: 26px;
            }
          }

          .user_register_check {
            width: 100%;
            min-height: 36px;
            display: flex;

            .textbox {
              flex: 1;
              min-height: 10px;
              font-size: 13px;
              color: white;

              // 确保 a 标签样式生效，包括动态插入的内容
              a,
              ::v-deep(a) {
                color: #00ffe0 !important;
                text-decoration: none !important;
                font-weight: 500 !important;

                &:hover {
                  color: #00d4c4 !important;
                  text-decoration: underline !important;
                }

                &:visited {
                  color: #00ffe0 !important;
                }

                &:active {
                  color: #00b8aa !important;
                }

                &:focus {
                  color: #00ffe0 !important;
                  outline: none !important;
                }
              }
            }

            // 保持原有的选择器作为备用
            .textbox>a {
              color: #00ffe0 !important;
            }

            // 针对 v-html 插入的内容使用更高优先级
            ::v-deep(.textbox a) {
              color: #00ffe0 !important;
              text-decoration: none !important;
              font-weight: 500 !important;
            }

            // 专门针对 atext 类的样式
            ::v-deep(.textbox .atext) {
              color: #00ffe0 !important;
              text-decoration: none !important;
              font-weight: 500 !important;

              &:hover {
                color: #00d4c4 !important;
                text-decoration: underline !important;
              }

              &:visited {
                color: #00ffe0 !important;
              }

              &:active {
                color: #00b8aa !important;
              }
            }

            ::v-deep(.el-checkbox) {
              width: 22px;
              height: 22px;
              margin-right: 17px;
              margin-top: 8px;

              .el-checkbox__input {
                width: 100%;
                height: 100%;

                .el-checkbox__original {
                  width: 22px !important;
                  height: 22px !important;
                }

                .el-checkbox__inner {
                  width: 22px !important;
                  height: 22px !important;
                  background-color: transparent !important;
                  border-color: #4b50e6;
                }
              }
            }

            margin-bottom: 82px;
          }

          .user_register_loginbtn {
            width: 226px;
            height: 38px;
            border-radius: 18px;
            opacity: 1;
            background: linear-gradient(257deg, #e250e5 12%, #4b50e6 87%);
            box-sizing: border-box;
            border: 1px solid #5142fc;
            margin: auto;
            font-size: 18px;
            color: #ffffff;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }
      }
    }

    .Records_conent {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding-left: 43px;
      padding-right: 43px;
      display: flex;
      flex-direction: column;
      overflow-y: scroll;

      // align-items: center;
      .Records_top {
        display: flex;
        height: 48px;
        align-items: center;

        .Records_search {
          width: 370px;
          display: flex;
          align-items: center;
          // width: 100%;
          height: 48px;
          border-radius: 24px;
          opacity: 1;
          box-sizing: border-box;
          border: 1px solid #5142fc;
          margin-right: 30px;

          // margin-bottom: 93px;
          input {
            border: none;
            flex: 1;
            flex-shrink: 0;
            height: 26px;
            margin-left: 52px;
            background: none;
            outline: none;
            outline: 0;
            font-size: 16px;
            color: #00ffe0;
            font-weight: normal;
          }

          input::placeholder {
            color: white;
            // font-weight: 400;
          }

          .sreach_icon {
            margin-right: 30px;
            width: 40px;
            height: 40px;
            border-radius: 50%;

            display: flex;
            justify-content: center;
            align-items: center;

            img {
              width: 22px;
              height: 22px;
            }
          }

          .sreach_icon:hover {
            background: linear-gradient(180deg,
                #1a2734 0%,
                rgba(75, 80, 230, 0.3) 100%);
          }
        }

        .timeselect {
          width: 320px;
          height: 50px;

          ::v-deep(.el-date-editor.el-input__wrapper) {
            height: 46px !important;
            width: 320px !important;
            background-color: transparent !important;
            border-radius: 24px !important;
            border: 1px solid #5142fc !important;
            box-shadow: none !important;

          }

          ::v-deep(.el-date-editor .el-range-input) {
            color: rgba(255, 255, 255, 0.6) !important;
            font-size: 16px !important;
            height: 30px !important;
          }

          ::v-deep(.el-date-editor .el-range-separator) {
            color: rgba(255, 255, 255, 0.6) !important;
          }
        }
      }

      .Records_box {
        width: 100%;
        flex: 1;
        overflow-y: scroll;

        margin-top: 14.5px;
        padding-top: 20px;

        .friends_list_item {
          width: 100%;
          height: 100%;
          flex: 1;
          overflow-y: scroll;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;

          img {
            height: 270px;
          }

          .bottomtext_text {
            width: 249px;
            min-height: 26px;
            margin: auto;
            text-align: center;
            margin-top: 18px;
            margin-bottom: 30px;
            font-size: 26px;
            font-weight: 600;
            color: white;
          }
        }

        .Favorites_list_item {
          width: 100%;
          min-height: 370px;

          .Favorites_list_title {
            width: 100%;
            height: 26px;
            font-size: 18px;
            color: #00ffe0;
            // font-weight: bold;
          }

          .Favorites_cardconent {
            width: 100%;
            min-height: 221px;
            margin: 27px auto 57px;
            display: grid;
            flex-wrap: wrap;
            grid-template-columns: repeat(4, 210px);
            grid-gap: 7px;
            justify-content: center;

            .Favorites_card {
              width: 210px;
              height: 240px;
              border-radius: 5px;

              flex-shrink: 0;
              // margin-bottom: 20px;
              overflow: hidden;
            }
          }
        }
      }
    }

    .Feedback_conent {
      width: 100%;
      height: 100%;
      box-sizing: border-box;
      padding-left: 60px;
      padding-right: 60px;
      display: flex;
      flex-direction: column;
      align-items: center;

      ::v-deep(.el-input__wrapper) {
        background: transparent;
      }

      ::v-deep(.el-form-item__error) {
        // top: calc(100% + 20px);
        font-size: 18px;
        top: 113% !important;
      }

      .Feedback_box {
        width: 100%;
        flex: 1;
        overflow-y: scroll;

        ::v-deep(.el-select__placeholder) {
          color: #cacaca !important;
        }

        .Feedback_item {
          width: 100%;
          min-height: 100px;
          margin-bottom: 58px;

          .Feedback_title {
            width: 100%;
            height: 26px;
            font-size: 18px;
            color: #00ffe0;
            margin-bottom: 18px;
          }

          .Feedback_input {
            width: 100%;
            height: 60px;
            background: #323f74;
            box-sizing: border-box;
            border-radius: 10px;
            display: flex;
            align-items: center;

            // [data-v-720cb8b3]
            ::v-deep(.el-form-item) {
              height: 100%;
            }

            ::v-deep(.el-input__inner) {
              font-size: 18px !important;
              color: white !important
            }

            ::v-deep(.el-input__wrapper) {
              box-shadow: none !important;
              padding: 0 !important;
            }

            ::v-deep(.el-form-item__content) {
              padding-left: 34px;
              padding-right: 34px;
            }
          }

          .Feedback_textarea {
            width: 100%;
            height: 166px;
            background: #323f74;
            color: white;
            border-radius: 15px;

            ::v-deep(.el-textarea__inner) {
              color: #cacaca;
              padding: 10px !important;
              box-sizing: border-box;
            }

            .texts {
              height: 100% !important;
              color: white;
            }
          }

          .FeedbackScreenshot {
            width: 100%;
            height: 210px;

            .updatebox {
              width: 100%;
              height: 100%;
              display: flex;

              // align-items: center;
              // background: red;
              .imgbox {
                width: 170px;
                height: 170px;
                background: #323f74;
                border-radius: 15px;
                color: white;
                display: flex;
                justify-content: center;
                align-items: center;
                font-size: 50px;
                color: #00ffe0;
                margin-right: 10px;
                box-sizing: border-box;
                padding: 15px;
                position: relative;
                overflow: hidden;

                .delete {
                  width: 20px;
                  height: 20px;
                  background: rgba(0, 255, 224, 0.7);
                  position: absolute;
                  top: 2px;
                  right: 2px;
                  border-radius: 50%;
                  font-size: 25px;
                  text-align: center;
                  line-height: 20px;
                  transform: rotate(45deg);
                  color: rgba(11, 20, 71, 1);
                  box-sizing: border-box;
                  // padding-right: 20px;
                }

                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 10px;
                }
              }

              .uploadbox {}
            }

            .jietu {
              width: 170px;
              height: 30px;
              font-size: 16px;
              box-sizing: border-box;
              display: flex;
              align-items: center;
              justify-content: center;
              border-radius: 10px;
              color: #323f74;
              background: #00ffe0;
              font-weight: 900;
              margin-top: 10px;
            }

            // .textbottom{
            //   height: 20px;
            //   width: 100%;
            //   font-size:14px;
            //     color:white;
            // }
          }
        }

        .Feedback_btn {
          // display: flex;
          color: #323f74;
          font-size: 20px;
          font-weight: 900;
          margin: auto;
          width: 226px;
          height: 50px;
          background: #00ffe0;
          border-radius: 15px;
          position: relative;
          bottom: 20px;
          transition-duration: 0.2s;

          line-height: 50px;
          text-align: center;
        }

        .Feedback_btn:active {
          transform: scale(0.95);
        }

        .Feedback_btn:hover {
          opacity: 0.7;
        }
      }
    }
  }
}

// 全局 atext 样式
.atext {
  color: #00ffe0 !important;
  text-decoration: none !important;
  font-weight: 500 !important;

  &:hover {
    color: #00d4c4 !important;
    text-decoration: underline !important;
  }

  &:visited {
    color: #00ffe0 !important;
  }

  &:active {
    color: #00b8aa !important;
  }

  &:focus {
    color: #00ffe0 !important;
    outline: none !important;
  }
}
</style>




<style lang="less">
.mySelectStyle .el-select-dropdown {
  width: 200px !important;

}

//下拉框的背景色
.el-select-dropdown__item {
  background: transparent !important;
}

//下拉框的链接小方块
.el-select-dropdown__item.is-active {
  // background: #2A77C6 !important;
}

//鼠标移动上去的选中色
.el-select-dropdown__item.hover,
//下拉框背景色
.el-popper.is-light.mySelectStyle {
  width: auto;
  height: auto;
  background: #323f74 !important;
  // background: red !important;
  border: 1px solid #323f74 !important;
}

//下拉框的链接小方块
.mySelectStyle.el-popper[data-popper-placement^='bottom'] .el-popper__arrow::before {
  background: #323f74 !important;
  border: 1px solid #323f74 !important;
  // display: none;
  translate: round(0deg);
}

.mySelectStyle.el-popper[data-popper-placement^='top'] .el-popper__arrow::before {
  background: #254277 !important;
  // red
  //  background: red !important;
  // border: 1px solid #254277 !important;
}

//鼠标移动上去的选中色
.mySelectStyle {
  position: relative;

  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background: rgba(230, 230, 250, 0.2) !important;
  }

  //下拉框的文本颜色
  .el-select-dropdown__item {
    height: 35px !important;
    color: white !important;
    font-family: Archivo Narrow !important;
    font-size: 14px;
    padding: 0 32px 0 20px !important;
  }

  //选中之后的颜色
  .el-select-dropdown__item.selected {
    background: rgba(11, 101, 135, 1) !important;
  }
}

.date-style {
  //#00ffd2

  border: 1px solid #0b1447 !important;
  border-radius: 25px !important;
  // background: #010201 !important;
  background: #0b1447 !important;
  overflow: hidden;

  .el-picker-panel {
    background: none !important;
  }

  .el-input--small .el-input__inner {
    background: #0b1447 !important;
  }

  .el-picker-panel__icon-btn {
    color: #00ffd2 !important;
  }

  .el-input__wrapper {
    background: #0b1447 !important;
  }

  .el-date-table td.start-date .el-date-table-cell__text {
    background: #0b1447 !important;
  }

  .el-date-table td.end-date .el-date-table-cell__text {
    background: #0b1447 !important;
  }

  .el-picker-panel__footer {
    background: #0b1447 !important;
  }

  .el-date-table td.today .el-date-table-cell__text {
    color: #00ffd2 !important;
  }

  .el-date-editor .el-range-separator {
    color: #d8d8d8 !important;
  }
}
</style>
